import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";

import { AppContext } from "../AppContext.js";
import { NEW_ENTRY } from "../ds/App_Constants.js";
import { BaseBean, NodeData, RestReportBean } from "../ds/client_ds.js";
import {
  AddressBean,
  BankAccountSearchCriteria,
  CheckTransactionBean,
  CheckTransactionGLAccountAppliedAmountBean,
  CheckTransactionInvoiceLineBean,
  CheckTransactionLetterOfCreditLineBean,
  CheckTransactionPrintOutRequest,
  CheckTransactionSearchCriteria,
  LetterOfCreditSearchCriteria,
  RestCheckTransactionBeanRequest,
  RestCheckTransactionListRequest,
  RestCheckTransactionPrintListRequest,
  RestCheckTransactionRequest,
  RestEntityUnLockRequest,
  RestLetterOfCreditListRequest,
  RestPageListBean,
  RestReadRequest,
  RestVendorInvoiceListRequest,
  RestVendorListRequest,
  VendorInvoiceSearchCriteria,
  VendorSearchCriteria,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import {
  AddIcon,
  CancelIcon,
  DeleteIcon,
  DropDwnDown,
  DropDwnUp,
} from "../gui_components/Icons.js";
import {
  AddressComponent,
  AlertToolBox,
  DatePickerComponent,
  InputCheckbox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { CheckTransactionLookupHandler } from "../lookup/CheckTransactionLookupHandler";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { LetterOfCreditLookupHandler } from "../lookup/LetterOfCreditLookupHandler.js";
import { VendorInvoiceLookupHandler } from "../lookup/VendorInvoiceLookupHandler.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { PopupLocModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { AccountPayableService } from "../services/AccountPayableService.js";
import { MasterService } from "../services/MasterService.js";
import { ReportService } from "../services/ReportService.js";
import { VendorService } from "../services/VendorService.js";
import { CheckTransactionToolBar } from "../toolBar/CheckTransactionToolBar.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
class CheckTransactionList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.invoiceRef = React.createRef();
    this.locRef = React.createRef();
    this.state = {
      pageTitle: "Check Transaction Maintenance",
      check_transaction_list: [],
      pageList: new RestPageListBean(),
      isLoading: false,
      criteria: new CheckTransactionSearchCriteria(),
      checkTransactionData: new CheckTransactionBean(),
      addressData: new AddressBean(),
      isDisabledFields: false,
      currentPageNumber: 0,
      totalCount: 0,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      isShowPDFReportButton: false,
      isCheckTransactionEntryFormOpen: false,
      isCheckTransactionListFormOpen: true,
      isCheckTransactionHistoryFormOpen: false,
      isCheckTransactionAddOpen: false,
      isShowApproveButton: false,
      isShowPrintButton: false,
      isShowCancelButton: false,
      isShowRePrintButton: false,
      error_list: [],
      expenseTypes: [],
      expenseSubTypes: [],
      transactionTypes: [],
      currencies: [],
      banks: [],
      vendor_List: new Array(),
      isShowNodes: false,
      selectedNodeKey: "headerView",
      nodeList: [],
      moduleForPopup: [],
      isShowPopup: false,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isResetView: true,
      moduleOrderStatus: "",
      isMaintenanceMode: true,
      isSpecialViewMode: false,
      isCheckType: true,
      isWireType: false,
      isWirewithLCType: false,
      isShowLocPopup: false,
      isShowMultiInvoicePopup: false,
      isShowInvoicePopup: false,
      letterOfCreditData: new CheckTransactionLetterOfCreditLineBean(),
      checkTransactionLineData: new CheckTransactionInvoiceLineBean(),
      isShowAlertLvl3: false,
      isShowAlertLvl4: false,
      isShowAlertLvl5: false,
      availableInvoice: [],
      selectedInvoice: [],
      vendorInvoiceList: [],
      selectedList: [],
      letterOfCreditLookupHandler: null,
      expenseTypeLookupHandler: null,
      overAllInvLines: [],
      isShowPrintPopup: false,
      isShowAutoCompleteTransTypeList: false,
      transTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteBankList: false,
      bankPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteExpenseTypeList: false,
      expenseTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteExpenseSubTypeList: false,
      expenseSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteInvExpenseTypeList: false,
      invExpenseTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteInvExpenseSubTypeList: false,
      invExpenseSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCurrencyList: false,
      currencyPageListForAutoCompleteList: new Array(),
      isShowInvoiceModule: false,
      isShowAutoCompleteVendorList: false,
      vendorPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteVendorInvoiceList: false,
      vendorInvoicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLetterOfCreditList: false,
      letterOfCreditPageListForAutoCompleteList: new Array(),
      isManualinvoiceEntry: false,
      isDisablePopupFields: false,
      isShowLocModule: false,
      isShowLookup: true,
      order: "asc",
      isVoided: false,
      isPrinted: false,
      checkNumber: 0,
      isShowAddressPopup: false,
      showAutoCompleteCityList: false,
      cityPageListForAutoCompleteList: new Array(),
      cityList: [],
      stateList: [],
      countryList: [],
      showAutoCompleteStateList: false,
      statePageListForAutoCompleteList: new Array(),
      showAutoCompleteCountryList: false,
      countryPageListForAutoCompleteList: new Array(),
      sortField: "",
      printHistoriesList: [],
      statusTracksList: [],
      inVoiceSortingLines: [],
      locLineList: [],
      isReseted: false,
      isViewMode: false,

      isShowGlAccountPopup: false,
      glAccountLinedata: new CheckTransactionGLAccountAppliedAmountBean(),
      glAccountLines: [],
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    ModuleUtils.getCheckTransactionStatusList();
    this.state.criteria = new CheckTransactionSearchCriteria();
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new RestPageListBean();
    this.state.pageList.pageSize = 50;
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      this.editCheckTransaction(this.props.code);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
    }
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let expenseTypes = this.state.expenseTypes;
    expenseTypes = attribute_cache.expenseTypes;
    // let expenseSubTypes = this.state.expenseSubTypes;
    // expenseSubTypes = attribute_cache.expenseSubTypes;
    this.state.expenseSubTypes = [];
    let expenseSubTypes = attribute_cache.expenseSubTypes;
    if (!isEmptyArray(expenseSubTypes))
      expenseSubTypes.map((ent) => {
        this.state.expenseSubTypes.push(ent);
      });
    this.state.cityList = [];
    let cityList = attribute_cache.cities;
    cityList.map((ent) => {
      this.state.cityList.push(ent);
    });

    this.state.stateList = [];
    let stateList = attribute_cache.states;
    stateList.map((ent) => {
      this.state.stateList.push(ent);
    });
    this.state.countryList = [];
    let countryList = attribute_cache.countries;
    countryList.map((ent) => {
      this.state.countryList.push(ent);
    });
    let banks = this.state.banks;
    banks = attribute_cache.bankAccounts;
    let currencies = this.state.currencies;
    currencies = attribute_cache.currencies;
    let transactionTypes = this.state.transactionTypes;
    transactionTypes = attribute_cache.transactionTypes;
    this.setState({
      expenseSubTypes: expenseSubTypes,
      expenseTypes: expenseTypes,
      transactionTypes: transactionTypes,
      currencies: currencies,
      banks: banks,
    });
    this.state.expenseTypes = expenseTypes;
    this.getVendorList();
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let checkTransactionLookupHandler = new CheckTransactionLookupHandler(
      this.companyCode,
      "CheckTransaction"
    );
    this.setState({
      checkTransactionLookupHandler: checkTransactionLookupHandler,
    });
    let letterOfCreditLookupHandler = new LetterOfCreditLookupHandler(
      this.companyCode,
      "Letter Of Credits"
    );
    this.setState({ letterOfCreditLookupHandler: letterOfCreditLookupHandler });
    let expenseTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.expenseTypes,
      "Expense Type"
    );
    this.setState({ expenseTypeLookupHandler: expenseTypeLookupHandler });
    let expenseSubTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.expenseSubTypes,
      "Expense Sub Type"
    );
    this.setState({ expenseSubTypeLookupHandler: expenseSubTypeLookupHandler });
    let currencyLookupHandler = new GenericAttributeLookupHandler(
      this.state.currencies,
      "Currency"
    );
    this.setState({ currencyLookupHandler: currencyLookupHandler });
  };
  moduleCaption = "Check Transaction Maintenance";
  addNewEntry = () => {
    let checkTransactionData = new CheckTransactionBean();
    checkTransactionData.companyCode = this.companyCode;
    checkTransactionData.code = NEW_ENTRY;
    checkTransactionData.adjustedExchangeRate = 1;
    checkTransactionData.currencyCode = "USD";
    checkTransactionData.bankCurrencyCode = "USD";
    checkTransactionData.transactionType = "CHECK";
    checkTransactionData.status = LogicConstants.CHECK_TRANSACTION_OPEN_STATUS;
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    checkTransactionData.checkDate = currentDate;
    checkTransactionData.createdDate = currentDate;
    checkTransactionData.wireTransferDate = currentDate;
    if (
      !isEmptyString(this.state.moduleKeyCode) ||
      this.state.moduleKeyCode != NEW_ENTRY
    )
      checkTransactionData.code = this.state.moduleKeyCode;
    else checkTransactionData.code = NEW_ENTRY;
    if (this.state.moduleKeyCode == NEW_ENTRY) {
      this.isLocked = false;
    } else {
      this.isLocked = true;
    }
    let pageTitle = this.moduleCaption + " - NEW";
    this.setState({
      checkTransactionData: checkTransactionData,
      pageTitle: pageTitle,
      addressData: new AddressBean(),
      isCheckType: true,
      checkNumber: 0,
      printHistoriesList: [],
      statusTracksList: [],
      inVoiceSortingLines: [],
      locLineList: [],
      glAccountLines: [],
    });
    this.state.checkTransactionData = checkTransactionData;
    this.state.isDisabledFields = false;
    this.openEntryForm();
  };
  unlockCheckTransaction = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.CheckTransactionMaintenance_IsAccessible()) {
      AccountPayableService.unLockCheckTransactionNumber(
        request,
        this.unlockCheckTransactionResponse,
        this.unlockCheckTransactionError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unlockCheckTransactionResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editCheckTransaction(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockCheckTransactionError = (error) => {
    ShowError("Error : ", error);
  };
  getVendorList = () => {
    let criteria = new VendorSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = new RestPageListBean();
    let requestInput = new RestVendorListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    if (SecurityAccessManager.CheckTransactionMaintenance_IsAccessible()) {
      VendorService.getVendorPageList(
        requestInput,
        this.getVendorPageListResponse,
        this.getVendorPageListError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getVendorPageListResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.vendorPageList) &&
      !isEmptyArray(response.data.vendorPageList.vendors)
    ) {
      const vendor_List = response.data.vendorPageList.vendors;
      this.setState({ vendor_List: vendor_List });
    }
  };
  getVendorPageListError = (error) => {
    ShowError("Error : ", error);
  };
  moduleExit = () => {
    let checkTransactionData = this.state.checkTransactionData;
    if (checkTransactionData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockCheckTransaction(checkTransactionData.code);
      } else {
        this.isLocked = false;
      }

      this.props.onModuleExit();
    }
  };
  filterCheckTransaction = () => {
    this.loadPage(1);
  };
  resetfilteredCheckTransaction = () => {
    let criteria = new CheckTransactionSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadCheckTransactionPage();
  };
  approveCheckTransaction = () => {
    this.setState({
      isLoading: true,
      loadingText: "Approving",
    });
    let checkTransactionData = this.state.checkTransactionData;
    let inputRequest = new RestCheckTransactionRequest();
    inputRequest.checkTransactionBean = checkTransactionData;
    inputRequest.isLockRequired = true;
    if (SecurityAccessManager.CheckTransactionApprove_IsAccessible()) {
      AccountPayableService.approveCheckTransaction(
        inputRequest,
        this.approveCheckTransactionResponse,
        this.approveCheckTransactionError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  approveCheckTransactionResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleresponse(response.data);
    if (!isEmpty(response.data) && !isEmpty(response.data.checkTransaction)) {
      let checkTransactionData = response.data.checkTransaction;
      this.setState({ checkTransactionData: checkTransactionData });

      if (this.isLocked) {
        this.code = checkTransactionData.code;
        this.unlockCheckTransaction(checkTransactionData.code);
      }
    }
  };
  approveCheckTransactionError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error :" + error);
  };
  cancelCheckTransaction = () => {
    this.setState({
      isLoading: true,
      loadingText: "Cancelling Check Transaction ..",
    });
    let checkTransactionData = this.state.checkTransactionData;
    let inputRequest = new RestCheckTransactionBeanRequest();
    inputRequest.companyCode = this.companyCode;
    inputRequest.code = checkTransactionData.code;
    inputRequest.checkTransaction = checkTransactionData;
    inputRequest.checkNumber = checkTransactionData.checkNumber;
    inputRequest.isLockRequired = true;
    inputRequest.isLoadChildren = true;
    if (SecurityAccessManager.CheckTransactionCancel_IsAccessible()) {
      AccountPayableService.voidedCheckTransaction(
        checkTransactionData,
        this.cancelCheckTransactionResponse,
        this.cancelCheckTransactionError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  cancelCheckTransactionResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleresponse(response.data);
    if (!isEmpty(response.data) && !isEmpty(response.data.checkTransaction)) {
      let checkTransactionData = response.data.checkTransaction;
      this.setState({ checkTransactionData: checkTransactionData });

      //this.unlockCheckTransaction(checkTransactionData.code);
      // this.editCheckTransaction(checkTransactionData.code);

      if (this.isLocked) {
        this.code = checkTransactionData.code;
        this.unlockCheckTransaction(checkTransactionData.code);
      }
    }
  };
  cancelCheckTransactionError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error :" + error);
  };
  generatePDF = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating PDF ..",
    });
    this.generateReport(1);
  };
  downloadReportResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.reportResult) &&
      !isEmpty(response.data.reportResult.reportFileID)
    ) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
  };
   downloadReportResponseForExcel = (response) => {
      this.setState({
        isLoading: false,
        loadingText: "",
      });
      if (
        !isEmpty(response.data) &&
        !isEmpty(response.data.reportResult) &&
        !isEmpty(response.data.reportResult.reportFileID)
      ) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
        // window.open(this.report_url + reportFilePath);
      }
    };
  downloadReportError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  generateReport = (reportType) => {
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let checkTransactionData = this.state.checkTransactionData;
    let requestInput = new CheckTransactionPrintOutRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.checkTransactionNumber = checkTransactionData.code;
    requestInput.input = reportBean;
    if (reportBean.reportType == 1) {
      if (SecurityAccessManager.CheckTransactionPDFReport_IsAccessible()) {
        ReportService.generateCheckTransactionPrintOutReport(
          requestInput,
          this.downloadReportResponse,
          this.downloadReportError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else if (reportBean.reportType == 2) {
      if (SecurityAccessManager.CheckTransactionExcelReport_IsAccessible()) {
        ReportService.generateCheckTransactionPrintOutReport(
          requestInput,
          this.downloadReportResponseForExcel,
          this.downloadReportError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  printCheckTransaction = () => {
    this.printCheckTransactionEntryForm();
  };
  printCheck = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Printing ..",
      });
      let checkTransactionData = this.state.checkTransactionData;
      checkTransactionData.taxPercentage = 0;
      checkTransactionData.checkNumber = this.state.checkNumber;
      let criteria = new RestCheckTransactionPrintListRequest();
      criteria.chkTransactionData = checkTransactionData;
      criteria.checkNumber = this.state.checkNumber;
      if (
        checkTransactionData.status ===
        LogicConstants.CHECK_TRANSACTION_PRINTED_STATUS
      ) {
        if (SecurityAccessManager.CheckTransactionReprint_IsAccessible()) {
          AccountPayableService.rePrintCheckTransaction(
            criteria,
            this.loadCheckTransactionResponse,
            this.loadCheckTransactionError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (SecurityAccessManager.CheckTransactionPrint_IsAccessible()) {
          AccountPayableService.printCheckTransaction(
            criteria,
            this.loadCheckTransactionResponse,
            this.loadCheckTransactionError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  loadCheckTransactionResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.checkTransactionPrintResult != null &&
      response.data.checkTransactionPrintResult.reportResult != null
    ) {
      if (
        !isEmptyString(
          response.data.checkTransactionPrintResult.reportResult.reportFileID
        )
      ) {
        let reportFilePath =
          response.data.checkTransactionPrintResult.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
        // this.closeCheckTransactionPrint();
        this.setState({ isShowPrintPopup: false });

        // this.unlockCheckTransaction(
        //   response.data.checkTransactionPrintResult.checkTransaction.code
        // );
        // this.editCheckTransaction(
        //   response.data.checkTransactionPrintResult.checkTransaction.code
        // );

        if (this.isLocked) {
          this.code =
            response.data.checkTransactionPrintResult.checkTransaction.code;
          this.unlockCheckTransaction(
            response.data.checkTransactionPrintResult.checkTransaction.code
          );
        }
      }
    }
  };
  loadCheckTransactionError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : ", error);
  };
  closeCheckTransactionPrint = (e) => {
    if (e.detail == 1) this.setState({ isShowPrintPopup: false });
  };
  editCheckTransaction = (checkTransactionCode) => {
    this.setState({
      isLoading: true,
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = checkTransactionCode;
    let isLockRequired = NEW_ENTRY === checkTransactionCode ? false : true;
    readrestInput.isLockRequired = isLockRequired;
    if (SecurityAccessManager.CheckTransactionMaintenance_IsAccessible()) {
      AccountPayableService.initCheckTransactionModule(
        readrestInput,
        this.readCheckTransactionResponse,
        this.readCheckTransactionError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readCheckTransactionResponse = (response) => {
    let statusTrack = [];
    let printHistoryList = [];
    let invoiceLines = [];
    if (response.data != null) {
      let errMsg = "";
      if (response.data.lockResponse != null) {
        if (!isEmpty(response.data.lockResponse.errors)) {
          this.showErrorMessage(response.data.lockResponse);
          this.state.isViewMode = true;
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (response.data.mainOperationResponse.errors != null) {
          response.data.mainOperationResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
      }
      if (response.data.additionalOperationResponse != null) {
        if (response.data.additionalOperationResponse.errors != null) {
          response.data.additionalOperationResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
      }
      if (response.data.printReportResponse != null) {
        if (response.data.printReportResponse.errors != null) {
          response.data.printReportResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (
          errMsg !=
          " Check Transaction Number [" +
            this.state.moduleKeyCode +
            "] Not Read Successfully"
        ) {
          this.showErrorMessage(response.data.mainOperationResponse);
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (response.data.mainOperationResponse.checkTransaction != null) {
          const checkTransactionData =
            response.data.mainOperationResponse.checkTransaction;
          if (checkTransactionData.taxPercentage == null) {
            checkTransactionData.taxPercentage = 0;
          }
          if (!isEmptyArray(checkTransactionData.invoiceLines)) {
            checkTransactionData.invoiceLines.map((ln) => {
              if (ln.invoiceDiscountAmount == null) {
                ln.invoiceDiscountAmount = 0;
              }
            });
          }
          let moduleKeyCode = checkTransactionData.code;
          let pageTitle = this.moduleCaption + " - EDIT";
          if (checkTransactionData.transactionType == "WIREWITHLC") {
            this.setState({
              isWirewithLCType: true,
              isCheckType: false,
              isWireType: false,
            });
          } else if (checkTransactionData.transactionType == "CHECK") {
            this.setState({
              isCheckType: true,
              isWirewithLCType: false,
              isWireType: false,
            });
          } else if (checkTransactionData.transactionType == "WIRE") {
            this.setState({
              isWireType: true,
              isWirewithLCType: false,
              isCheckType: false,
            });
          }
          if (!isEmptyArray(checkTransactionData.printHistories)) {
            printHistoryList = checkTransactionData.printHistories;
          }
          if (!isEmptyArray(checkTransactionData.statusTracks)) {
            statusTrack = checkTransactionData.statusTracks;
          }
          let invoiceLines = [];
          if (!isEmptyArray(checkTransactionData.invoiceLines)) {
            invoiceLines = checkTransactionData.invoiceLines;
          }
          let locLines = [];
          if (!isEmptyArray(checkTransactionData.letterOfCreditLines)) {
            locLines = checkTransactionData.letterOfCreditLines;
          }
          let glAmountLines = [];
          if (!isEmptyArray(checkTransactionData.glAppliedAmounts != null)) {
            glAmountLines = checkTransactionData.glAppliedAmounts;
          }
          this.setState({
            checkTransactionData: checkTransactionData,
            pageTitle: pageTitle,
            moduleKeyCode: moduleKeyCode,
            isLoading: false,
            printHistoriesList: printHistoryList,
            statusTracksList: statusTrack,
            inVoiceSortingLines: invoiceLines,
            glAccountLines: glAmountLines,
            locLineList: locLines,
          });
          this.state.checkTransactionData = checkTransactionData;
          this.isLocked = true;
          this.openEntryForm();
        } else {
          this.addNewEntry();
        }
      }
    }
    this.setState({
      isLoading: false,
    });
  };
  readCheckTransactionError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : ", error);
  };
  validateCheckTransactionData = (checkTransactionData) => {
    let isValidData = false;
    let err_list = [];
    let errorMessage = "";
    if (checkTransactionData == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(checkTransactionData.vendorCode)) {
        let errMsg = "Vendor Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(checkTransactionData.vendorName)) {
        let errMsg = "Vendor Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(checkTransactionData.bankCode)) {
        let errMsg = "Bank Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(checkTransactionData.bankName)) {
        let errMsg = "Bank Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (
        isEmptyString(checkTransactionData.invoiceLines) &&
        isEmptyArray(checkTransactionData.letterOfCreditLines)
      ) {
        let errMsg = "CheckTransaction Lines Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidData;
  };
  saveCheckTransaction = (checkTransactionData) => {
    let isValid = false;
    isValid = this.validateCheckTransactionData(checkTransactionData);
    if (isValid) {
      if (checkTransactionData.isFetched) {
        if (SecurityAccessManager.CheckTransactionEdit_IsAccessible()) {
          AccountPayableService.updateCheckTransaction(
            checkTransactionData,
            this.saveCheckTransactionResponse,
            this.saveCheckTransactionError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (SecurityAccessManager.CheckTransactionCreate_IsAccessible()) {
          AccountPayableService.createCheckTransaction(
            checkTransactionData,
            this.saveCheckTransactionResponse,
            this.saveCheckTransactionError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  saveCheckTransactionResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleresponse(response.data);
    if (response.data != null && response.data.checkTransaction != null) {
      let checkTransactionData = response.data.checkTransaction;
      this.setState({
        checkTransactionData: checkTransactionData,
      });

      if (!this.isLocked) {
        this.editCheckTransaction(checkTransactionData.code);
      } else {
        this.code = checkTransactionData.code;
        this.unlockCheckTransaction(checkTransactionData.code);
      }
    }
  };
  saveCheckTransactionError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : ", error);
  };
  openCheckTransactionForm = () => {
    this.setState({ isCheckTransactionAddOpen: true });
  };
  disableChecktransactionFormFields = () =>
    this.setState({ isDisabledFields: true });
  openEntryForm = () => {
    this.closeAllNodeViews();
    this.getNodeList();
    this.setState({
      isCheckTransactionListFormOpen: false,
      isCheckTransactionEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowPDFReportButton: true,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isShowNodes: true,
      isShowPrintButton: false,
      isShowRePrintButton: false,
      isShowModuleSearchContainer: true,
      isResetView: false,
      isCheckTransactionHistoryFormOpen: false,
      isShowAutoCompleteTransTypeList: false,
      transTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteBankList: false,
      bankPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteExpenseTypeList: false,
      expenseTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteExpenseSubTypeList: false,
      expenseSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteInvExpenseTypeList: false,
      invExpenseTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteInvExpenseSubTypeList: false,
      invExpenseSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCurrencyList: false,
      currencyPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteVendorList: false,
      vendorPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteVendorInvoiceList: false,
      vendorInvoicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLetterOfCreditList: false,
      letterOfCreditPageListForAutoCompleteList: new Array(),
      isVoided: false,
      isPrinted: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isCheckTransactionListFormOpen: false,
        disabled: false,
        isDisableNodeFields: false,
        isDisabledFields: false,
      });
    } else {
      this.setState({
        isDisabledFields: true,
        disabled: true,
        isVoided: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    let checkTransactionData = this.state.checkTransactionData;
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let status = ModuleUtils.getCheckTransactionStatusCaption(
      checkTransactionData.status
    );
    if (status !== undefined && status !== null) {
      moduleOrderStatus = status;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    if (
      checkTransactionData.status ==
      LogicConstants.CHECK_TRANSACTION_OPEN_STATUS
    ) {
      if (!isEmptyArray(checkTransactionData.letterOfCreditLines)) {
        this.setState({
          isShowRePrintButton: false,
          isShowApproveButton: true,
          isShowPrintButton: false,
          isShowSaveButton: true,
          isShowCancelButton: false,
          isVoided: false,
          isPrinted: false,
        });
      } else {
        this.setState({
          isShowRePrintButton: false,
          isShowApproveButton: false,
          isShowPrintButton: true,
          isShowSaveButton: true,
          isShowCancelButton: false,
          isVoided: false,
          isPrinted: false,
        });
      }
    }
    if (
      checkTransactionData.status ==
      LogicConstants.CHECK_TRANSACTION_PRINTED_STATUS
    ) {
      if (!isEmptyArray(checkTransactionData.letterOfCreditLines)) {
        this.setState({
          isShowRePrintButton: false,
          isShowApproveButton: false,
          isShowPrintButton: false,
          isShowSaveButton: false,
          isShowCancelButton: true,
          isVoided: false,
          isPrinted: true,
        });
      } else {
        this.setState({
          isShowRePrintButton: true,
          isShowApproveButton: false,
          isShowPrintButton: false,
          isShowSaveButton: false,
          isShowCancelButton: true,
          isVoided: false,
          isPrinted: true,
        });
      }
    }
    if (
      checkTransactionData.status ==
      LogicConstants.CHECK_TRANSACTION_VOIDED_STATUS
    ) {
      this.setState({
        isShowRePrintButton: false,
        isShowApproveButton: false,
        isShowPrintButton: false,
        isShowSaveButton: false,
        isShowCancelButton: false,
        isVoided: true,
        isPrinted: false,
      });
    }
    if (checkTransactionData.isFetched == false) {
      if (
        checkTransactionData.status ==
        LogicConstants.CHECK_TRANSACTION_OPEN_STATUS
      ) {
        this.setState({
          isShowRePrintButton: false,
          isShowApproveButton: false,
          isShowPrintButton: false,
          isShowSaveButton: true,
          isShowCancelButton: false,
          isShowPDFReportButton: false,
          isVoided: false,
          isPrinted: false,
        });
      }
    } else if (checkTransactionData.isFetched == true) {
      this.setState({
        isDisabledFields: true,
        isDisablePopupFields: true,
      });
    }
    if (this.state.isViewMode) {
      let pageTitle = this.moduleCaption + " - VIEW";
      this.setState({
        isDisabledFields: true,
        isDisablePopupFields: true,
        disabled: true,
        pageTitle: pageTitle,
        isVoided: true,
      });
    }
  };
  closeEntryForm = () => {
    this.closeAllNodeViews();
    let pageTitle = this.moduleCaption;
    this.setState({
      pageTitle: pageTitle,
      isCheckTransactionListFormOpen: true,
      isCheckTransactionEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: false,
      isShowPDFReportButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isShowPrintButton: false,
      isShowNodes: false,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isResetView: false,
      isCheckTransactionHistoryFormOpen: false,
      isMaintenanceMode: false,
      isCheckType: false,
      isWireType: false,
      isWirewithLCType: false,
      checkNumber: 0,
      isViewMode: false,
      isSpecialViewMode: false,
      isDisabledFields: false,
      isDisablePopupFields: false,
      inVoiceSortingLines: [],
      locLineList: [],
    });
  };

  printCheckTransactionEntryForm = () => {
    this.openPrintDetailDialog();
  };
  save = () => {
    this.saveCheckTransaction(this.state.checkTransactionData);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  openNewCheckTransactionEntryForm = () =>
    this.setState({
      isCheckTransactionListFormOpen: false,
      isCheckTransactionEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowPDFReportButton: true,
      isShowBackButton: true,
      isShowNodes: true,
      isShowModuleSearchContainer: true,
      isResetView: true,
    });
  getModuleListView = () => {
    let checkTransactionData = this.state.checkTransactionData;
    if (checkTransactionData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadCheckTransactionPage();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockCheckTransaction(checkTransactionData.code);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadCheckTransactionPage();
    }
  };
  resetView = () => {
    let check = this.state.checkTransactionData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unlockCheckTransaction(check.code);
    } else {
      this.isLocked = false;
    }
    let _checkTransactionData = new CheckTransactionBean();
    this.setState({
      checkTransactionData: _checkTransactionData,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isCheckType: true,
      isWireType: false,
      isWirewithLCType: false,
      isShowLookup: false,
      isShowAutoCompleteTransTypeList: false,
      transTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteBankList: false,
      bankPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteExpenseTypeList: false,
      expenseTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteExpenseSubTypeList: false,
      expenseSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteInvExpenseTypeList: false,
      invExpenseTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteInvExpenseSubTypeList: false,
      invExpenseSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCurrencyList: false,
      currencyPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteVendorList: false,
      vendorPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteVendorInvoiceList: false,
      vendorInvoicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLetterOfCreditList: false,
      letterOfCreditPageListForAutoCompleteList: new Array(),
      isManualinvoiceEntry: false,
      isDisablePopupFields: false,
      checkNumber: 0,
      printHistoriesList: [],
      statusTracksList: [],
      inVoiceSortingLines: [],
      letterOfCreditData: new CheckTransactionLetterOfCreditLineBean(),
      checkTransactionLineData: new CheckTransactionInvoiceLineBean(),
      overAllInvLines: [],
      glAccountLines: [],
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    // this.clearCheckTransactionLineValues();
    // this.clearLocDetails();
    this.clearMultiInvoices();
    this.hideAlertCallBack("", false);
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    this.editCheckTransaction(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  getNodeList = () => {
    let nodeList = [];
    let headerObject = this.getEmptyView();
    let historyObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "Header", headerObject);
    let historyNode = new NodeData("historyView", "History", historyObject);
    nodeList["headerView"] = headerNode;
    let checkTransactionData = this.state.checkTransactionData;
    if (checkTransactionData.isFetched == true) {
      nodeList["historyView"] = historyNode;
    }
    this.setState({ nodeList: nodeList });
  };
  getEmptyView() {
    return <div></div>;
  }
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setHeaderView();
    } else if (selectedNode == "historyView") {
      this.setHistoryView();
    }
  };
  loadCheckTransactionPage = () => {
    let loading = this.state.isLoading;
    loading = true;
    this.setState({ isLoading: loading });
    let requestInput = new RestCheckTransactionListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    if (SecurityAccessManager.CheckTransactionView_IsAccessible()) {
      AccountPayableService.getCheckTransactionPageList(
        requestInput,
        this.getCheckTransactionResponse,
        this.getCheckTransactionError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getCheckTransactionResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.pageList) &&
      !isEmptyArray(response.data.pageList.checkTransactions)
    ) {
      const check_transaction_list = response.data.pageList.checkTransactions;
      this.state.pageList.totalCount = response.data.pageList.totalCount;
      this.state.pageList.currentPage = response.data.pageList.currentPage;
      let loading = false;
      this.setState({
        isLoading: loading,
        check_transaction_list: check_transaction_list,
      });
    }
  };
  getCheckTransactionError = (error) => {
    ShowError("Error : ", error);
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = new Array();
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      response.infos.map((err) => (infoMsg = infoMsg + err.messageDescription));
      this.setState({
        alertMessage: infoMsg,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  closeAllNodeViews = () => {
    this.setState({
      isShowSaveButton: false,
      isCheckTransactionEntryFormOpen: false,
      isCheckTransactionListFormOpen: false,
      isCheckTransactionHistoryFormOpen: false,
    });
  };
  setHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isCheckTransactionEntryFormOpen: true,
      isCheckTransactionListFormOpen: false,
      isCheckTransactionHistoryFormOpen: false,
    });
  };
  setHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isCheckTransactionEntryFormOpen: false,
      isCheckTransactionListFormOpen: false,
      isCheckTransactionHistoryFormOpen: true,
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({ isShowPopup: isShowPopup, isShowAlert: isShowPopup });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    if (this.fabricStyleCodeRef.current != null) {
      this.fabricStyleCodeRef.current.clearValue();
      this.fabricStyleCodeRef.current.focus();
    }
    this.setState({ isShowAlert: isDisplayed });
  };
  openPrintDetailDialog() {
    this.setState({ isShowPrintPopup: true });
    let checkTransactionData = this.state.checkTransactionData;
    let checkNumber = 0;
    if (!isEmpty(checkTransactionData.checkNumber)) {
      checkNumber = parseFloat(checkTransactionData.checkNumber) + 1;
    } else {
      checkNumber = 1;
    }
    this.setState({
      checkNumber: checkNumber,
    });
  }
  manualEntryOnChange = (e) => {};
  onChange = (e) => {
    let temp_checkTransactionData = this.state.checkTransactionData;
    let checkTransactionLine = this.state.checkTransactionLineData;
    let isManualinvoiceEntry = this.state.isManualinvoiceEntry;
    if (e.target.name == "isManualEntry") {
      temp_checkTransactionData.isManualEntry = e.target.value;
      checkTransactionLine.isManualInvoiceFlag = e.target.value;
      // this.clearCheckTransactionLineValues();
      this.setState({
        checkTransactionLineData: new CheckTransactionInvoiceLineBean(),
        overAllInvLines: [],
      });
    }
    if (temp_checkTransactionData.isManualEntry != true) {
      isManualinvoiceEntry = true;
    } else {
      isManualinvoiceEntry = false;
    }
    temp_checkTransactionData[e.target.name] = e.target.value;

    this.setState({
      checkTransactionData: temp_checkTransactionData,
      checkTransactionLineData: checkTransactionLine,
      isManualinvoiceEntry: isManualinvoiceEntry,
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  getHistoryView() {
    return (
      <CheckTransactionHistoryDetailsForm
        {...this.state}
        printHistoriesList={this.state.printHistoriesList}
        statusTracksList={this.state.statusTracksList}
        handleSortingStatusTrackChange={this.handleSortingStatusTrackChange}
        handleSortingPrintHistoriesChange={
          this.handleSortingPrintHistoriesChange
        }
      />
    );
  }
  listFormOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  setTransactionType = (value) => {
    let isCheckType = false;
    let isWireType = false;
    let isWirewithLCType = false;

    if (value == "CHECK") {
      isCheckType = true;
    } else if (value == "WIRE") {
      isWireType = true;
    } else if (value == "WIREWITHLC") {
      isWirewithLCType = true;
    }
    let checkTransactionData = this.state.checkTransactionData;
    checkTransactionData.totalAmount = 0;
    checkTransactionData.invoiceLines = [];
    checkTransactionData.letterOfCreditLines = [];
    this.setState({
      isCheckType: isCheckType,
      isWireType: isWireType,
      isWirewithLCType: isWirewithLCType,
      checkTransactionData: checkTransactionData,
      inVoiceSortingLines: [],
      glAccountLines: [],
    });
  };
  openLetterOfCreditForm = (type) => {
    if (type == 1) {
      this.setState({
        isDisablePopupFields: true,
      });
    } else {
      this.setState({
        isDisablePopupFields: false,
      });
    }
    this.setState({ isShowLocPopup: true });
    setTimeout(() => {
      if (this.locRef.current != null) {
        this.locRef.current.focus();
      }
    }, 100);
  };
  validateLOCLines = (lineBean) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (lineBean == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(lineBean.letterOfCreditNumber)) {
        let errMsg = "LOC Number is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(lineBean.expenseType)) {
        let errMsg = "ExpenseType is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl5: true,
        isShowAlert: false,
      });
    } else {
      isValid = true;
      this.setState({ isShowAlertLvl5: true, isShowAlert: false });
    }
    return isValid;
  };
  getLOCMaxLineNumber() {
    let maxLineNumber = 0;
    let miscLine = this.state.checkTransactionData.letterOfCreditLines;
    if (miscLine.length > 0) {
      miscLine.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  }
  addLetterOfCredit = (e) => {
    if (e.detail == 1) {
      let checkTransactionData = this.state.checkTransactionData;
      let letterOfCreditData = this.state.letterOfCreditData;
      let locLines = checkTransactionData.letterOfCreditLines;
      let tempLocLine = [];
      let isValid = false;
      isValid = this.validateLOCLines(letterOfCreditData);
      if (isValid) {
        var lineNumber = this.getLOCMaxLineNumber();
        let isLineFound = false;
        if (!isEmptyArray(locLines)) {
          locLines.map((line, i) => {
            if (
              line.letterOfCreditNumber ==
              letterOfCreditData.letterOfCreditNumber
            ) {
              letterOfCreditData.lineNumber = line.lineNumber;
              locLines[i] = letterOfCreditData;
              isLineFound = true;
            } else if (line.lineNumber == letterOfCreditData.lineNumber) {
              locLines[i] = letterOfCreditData;
              isLineFound = true;
            }
          });
        }
        if (!isLineFound) {
          letterOfCreditData.lineNumber = ++lineNumber;
          locLines.push(letterOfCreditData);
        }
        checkTransactionData.letterOfCreditLines = locLines;
        tempLocLine = checkTransactionData.letterOfCreditLines;
        this.setState({
          checkTransactionData: checkTransactionData,
          isDisablePopupFields: true,
          locLineList: tempLocLine,
        });
        this.closeAlertModalCallBacklvl5(false);
        this.setTotalAmount(2);
      }
    }
  };
  closeLetterOfCreditForm = () => {
    this.setState({ isShowLocPopup: false });
  };
  onLetterCreditChange = (e) => {
    let letterOfCreditData = this.state.letterOfCreditData;
    letterOfCreditData[e.target.name] = e.target.value;
    this.setState({ letterOfCreditData: letterOfCreditData });
  };
  reArrangeLOCLines = (list) => {
    let maxLineNumber = 0;
    list.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  deleteLOCLine = (rowData) => {
    let checkTransactionData = this.state.checkTransactionData;
    let lineData = checkTransactionData.letterOfCreditLines;
    let tempLocLineData = [];
    if (!rowData.isFetched) {
      var index = lineData.indexOf(rowData);
      if (index > -1) {
        lineData.splice(index, 1);
      }
      checkTransactionData.letterOfCreditLines = lineData;
      tempLocLineData = checkTransactionData.letterOfCreditLines;
      this.reArrangeLOCLines(lineData);
      this.setState({
        checkTransactionData: checkTransactionData,
        locLineList: tempLocLineData,
      });
    }
  };
  getLocLineDetails = (rowData) => {
    let linedata = { ...rowData };
    this.setState({
      letterOfCreditData: linedata,
    });
    this.openLetterOfCreditForm(1);
  };
  validateButtons = (data) => {
    let isValidData = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.vendorCode)) {
        let errMsg = "VendorCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.bankCode)) {
        let errMsg = "BankCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidData;
  };
  openInvoiceForm = (type) => {
    let checkTransactionData = this.state.checkTransactionData;
    let checkTransactionLineData = this.state.checkTransactionLineData;
    var currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    checkTransactionLineData.invoiceDate = currentDate;
    checkTransactionLineData.invoiceDueDate = currentDate;
    checkTransactionLineData.currencyCode = "USD";
    checkTransactionLineData.isManualInvoiceFlag =
      checkTransactionData.isManualEntry;
    let isValid = false;
    isValid = this.validateButtons(checkTransactionData);
    if (isValid) {
      this.setState({
        isShowInvoicePopup: true,
      });
      if (type == 1) {
        this.setState({
          isDisablePopupFields: true,
          isManualinvoiceEntry: true,
        });
      } else {
        this.setState({
          isDisablePopupFields: false,
          checkTransactionLineData: checkTransactionLineData,
        });
        if (checkTransactionData.isManualEntry) {
          this.setState({ isManualinvoiceEntry: false });
        }
      }
    }

    setTimeout(() => {
      if (this.invoiceRef.current != null) {
        this.invoiceRef.current.focus();
      }
    }, 100);
  };
  openMultipleInvoiceForm = () => {
    let checkTransactionData = this.state.checkTransactionData;
    let isValid = false;
    isValid = this.validateButtons(checkTransactionData);
    if (isValid) {
      this.setState({ isShowMultiInvoicePopup: true });
      this.getVendorInvoices(checkTransactionData.vendorCode);
    }
  };
  getVendorInvoices = (vendorCode) => {
    let criteria = new VendorInvoiceSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.vendorCode = vendorCode;
    criteria.status = LogicConstants.VENDOR_INVOICE_APPROVE_STATUS;
    let requestInput = new RestVendorInvoiceListRequest();
    let pageList = new RestPageListBean();
    pageList.pageSize = 50;
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    if (SecurityAccessManager.CheckTransactionMaintenance_IsAccessible()) {
      AccountPayableService.getVendorInvoices(
        requestInput,
        this.loadVendorInvoiceResponse,
        this.loadVendorInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadVendorInvoiceResponse = (response) => {
    if (
      response.data != null &&
      response.data.vendorInvoicePageList != null &&
      response.data.vendorInvoicePageList.vendorInvoices != null
    ) {
      let vendor_invoices_list =
        response.data.vendorInvoicePageList.vendorInvoices;
      let vendorInvoiceList = [];
      let sampleList = [];
      vendor_invoices_list.map((ln) => {
        vendorInvoiceList.push(ln);
        sampleList.push(ln);
      });
      this.setState({
        vendorInvoiceList: vendorInvoiceList,
        availableInvoice: vendorInvoiceList,
      });
      let checkTransactionData = this.state.checkTransactionData;
      let selectedInvoice = this.state.selectedInvoice;
      if (
        checkTransactionData.invoiceLines != null &&
        !isEmptyArray(checkTransactionData.invoiceLines) &&
        this.state.isShowMultiInvoicePopup == true
      ) {
        checkTransactionData.invoiceLines.map((ln) => {
          sampleList.map((sl, i) => {
            if (ln.invoiceNumber == sl.code) {
              selectedInvoice.push(sl);
              sampleList.splice(i, 1);
            }
          });
        });
        this.setState({
          selectedInvoice: selectedInvoice,
          availableInvoice: sampleList,
        });
      }
    }
  };
  loadVendorInvoiceError = (error) => {
    ShowError("Error : ", error);
  };
  selectVendorInvoice = (e, value, rowData) => {
    if (e.detail == 1) {
      let availableInvoice = this.state.availableInvoice;
      let selectedInvoice = this.state.selectedInvoice;
      availableInvoice.map((ln, i) => {
        if (ln.code === value) {
          selectedInvoice.push(ln);
          availableInvoice.splice(i, 1);
        }
      });
      this.setState({
        availableInvoice: availableInvoice,
        selectedInvoice: selectedInvoice,
      });
    }
  };
  unSelectVendorInvoice = (e, value, rowData) => {
    if (e.detail == 1) {
      let availableInvoice = this.state.availableInvoice;
      let selectedInvoice = this.state.selectedInvoice;
      selectedInvoice.map((ln, i) => {
        if (ln.code === value) {
          availableInvoice.push(ln);
          selectedInvoice.splice(i, 1);
        }
      });
      this.setState({
        availableInvoice: availableInvoice,
        selectedInvoice: selectedInvoice,
      });
    }
  };
  onCheckTransactionLineChange = (e) => {
    let checkTransactionData = this.state.checkTransactionData;
    let checkTransactionLineData = this.state.checkTransactionLineData;
    checkTransactionLineData[e.target.name] = e.target.value;
    if (checkTransactionData.isManualEntry) {
      if (
        e.target.name == "invoiceGrandTotalAmount" ||
        e.target.name == "invoiceDiscountAmount"
      ) {
        checkTransactionLineData.invoiceLinePaidAmount =
          parseFloat(checkTransactionLineData.invoiceGrandTotalAmount) -
          parseFloat(checkTransactionLineData.invoiceDiscountAmount);
      }
    }

    this.setState({
      checkTransactionLineData: checkTransactionLineData,
    });
  };
  readVendorInvoice = (vendorInvoiceCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = vendorInvoiceCode;
    if (SecurityAccessManager.CheckTransactionMaintenance_IsAccessible()) {
      AccountPayableService.readVendorInvoice(
        readrestInput,
        this.readVendorInvoiceResponse,
        this.readVendorInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readVendorInvoiceResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.vendorInvoice)) {
      const vendorInvoiceList = response.data.vendorInvoice;
      let checkTransactionLine = new CheckTransactionInvoiceLineBean();
      checkTransactionLine.companyCode = this.companyCode;
      checkTransactionLine.checkTransactionNumber = NEW_ENTRY;
      checkTransactionLine.invoiceNumber = vendorInvoiceList.code;
      checkTransactionLine.invoiceDescription = vendorInvoiceList.description;
      checkTransactionLine.invoiceDate = vendorInvoiceList.invoiceDate;
      let currentDate = new Date();
      checkTransactionLine.invoiceDueDate =
        currentDate.toLocaleDateString("sv-SE");
      checkTransactionLine.invoiceGrandTotalAmount =
        vendorInvoiceList.grandTotalAmount;
      checkTransactionLine.invoiceOpenAmount = vendorInvoiceList.openAmount;
      checkTransactionLine.invoiceLinePaidAmount =
        vendorInvoiceList.grandTotalAmount;
      checkTransactionLine.isManualInvoiceFlag =
        this.state.checkTransactionData.isManualEntry;
      checkTransactionLine.expenseType = vendorInvoiceList.expenseType;
      checkTransactionLine.expenseSubType = vendorInvoiceList.expenseSubType;
      checkTransactionLine.currencyCode = vendorInvoiceList.currencyCode;
      this.setState({
        checkTransactionLineData: checkTransactionLine,
      });
    }
  };
  readVendorInvoiceError = (error) => {
    ShowError("Error : ", error);
  };
  onVendorCodeChange = (e) => {
    let vendorCode = e.target.value;
    this.state.isShowAutoCompleteVendorList = true;
    let tempData = this.state.checkTransactionData;
    let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
    if (isEmpty(vendorCode)) {
      this.state.isShowAutoCompleteVendorList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
      let tempData = this.state.checkTransactionData;
      tempData.vendorCode = "";
      tempData.vendorName = "";
      tempData.address = new AddressBean();
      let suggestion = [];
      this.setState({
        isShowAutoCompleteVendorList: showAutoCompleteList,
        checkTransactionData: tempData,
        vendorPageListForAutoCompleteList: suggestion,
        addressData: new AddressBean(),
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteList === true &&
      vendorCode !== ""
    ) {
      this.readVendorBySearchString(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({
      checkTransactionData: tempData,
    });
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading Vendor",
    });
    this.readVendor(e.target.value);
    this.state.isShowAutoCompleteVendorList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteVendorList: showAutoCompleteList,
    });
  };
  displayVendorAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteVendorList: showAutoCompleteList });
  };
  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.searchCriteria = searchCriteria;
    input.pageInput = pageList;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.readByVendorCodeResponseError
    );
  }
  readByVendorCodeResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.vendorPageList) &&
      !isEmptyArray(response.data.vendorPageList.vendors)
    ) {
      let vendorCodeData = response.data.vendorPageList.vendors;
      let simpleAutoCompleteList = new Array();
      if (vendorCodeData.length > 0 && vendorCodeData != null) {
        vendorCodeData.map((vendorCode) => {
          let simpleItemBean = {
            code: vendorCode.code,
            description: vendorCode.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        vendorPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  readByVendorCodeResponseError = (error) => {
    ShowError("Error : ", error);
  };
  setAddress(vendor) {
    let checkTransactionData = { ...this.state.checkTransactionData };
    if (vendor != null && vendor != undefined) {
      let vendorAddress = vendor.address;
      if (vendorAddress != null && vendorAddress != undefined) {
        let address = new AddressBean();
        address.address1 = vendorAddress.address1;
        address.address2 = vendorAddress.address2;
        address.city = vendorAddress.city;
        address.state = vendorAddress.state;
        address.country = vendorAddress.country;
        address.zip = vendorAddress.zip;
        address.email = vendorAddress.email;
        address.mobilePhone = vendorAddress.mobilePhone;
        address.phone1 = vendorAddress.phone1;
        address.phone2 = vendorAddress.phone2;
        address.fax = vendorAddress.fax;
        address.website = vendorAddress.website;
        address.contactPerson = vendor.code;
        checkTransactionData.address = { ...address };
      }
      // let addressData = { ...checkTransactionData.address };
      let addressData = new AddressBean();
      this.setState({
        checkTransactionData: checkTransactionData,
        addressData: addressData,
      });
    }
  }
  readVendorResponse = (response) => {
    if (response.data != null) {
      if (response.data.vendor != null) {
        let vendorData = response.data.vendor;
        let checkTransactionData = this.state.checkTransactionData;
        checkTransactionData.vendorCode = vendorData.code;
        checkTransactionData.vendorName = vendorData.description;
        this.setState({
          checkTransactionData: checkTransactionData,
          isShowInvoiceLookup: true,
        });
        let vendorCode = vendorData.code;
        let vendorInvoiceLookupHandler = new VendorInvoiceLookupHandler(
          this.companyCode,
          "VendorInvoice",
          vendorCode,
          "A"
        );
        this.setState({
          vendorInvoiceLookupHandler: vendorInvoiceLookupHandler,
        });
        this.getVendorInvoices(vendorData.code);
        this.setAddress(vendorData);
      }
    }
  };
  readVendorError = (error) => {};
  readVendor = (vendorCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = vendorCode;
    if (SecurityAccessManager.CheckTransactionMaintenance_IsAccessible()) {
      VendorService.readVendor(
        readrestInput,
        this.readVendorResponse,
        this.readVendorError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  setBankDetails = (value) => {
    let readrestInput = new BankAccountSearchCriteria();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = value;
    if (SecurityAccessManager.CheckTransactionMaintenance_IsAccessible()) {
      MasterService.readBankAccount(
        readrestInput,
        this.readBankResponse,
        this.readBankError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readBankResponse = (response) => {
    let tempCheckTransactionData = this.state.checkTransactionData;

    if (response.data != null && response.data.bankAccount != null) {
      const bankAccountList = response.data.bankAccount;
      tempCheckTransactionData.bankCode = bankAccountList.code;
      tempCheckTransactionData.bankName = bankAccountList.description;
      tempCheckTransactionData.bankCurrencyCode = bankAccountList.currencyCode;
      tempCheckTransactionData.currentCheckNumber =
        bankAccountList.currentCheckNumber;
      tempCheckTransactionData.checkNumber = bankAccountList.currentCheckNumber;
    }
    this.setState({ checkTransactionData: tempCheckTransactionData });
  };
  readBankError = (error) => {
    ShowError("Error : ", error);
  };
  getChecktransactionInvoiceLineDetails = (rowData) => {
    let checkTransactionInvoiceLinedata = { ...rowData };

    this.setState({
      checkTransactionLineData: checkTransactionInvoiceLinedata,
    });

    this.openInvoiceForm(1);
  };
  validateData = (checkData) => {
    let isValidData = false;
    let err_list = [];
    let errorMessage = "";
    if (checkData == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      let paidAmt = checkData.invoiceLinePaidAmount;
      let grandtot = checkData.invoiceGrandTotalAmount;
      if (parseInt(paidAmt) > parseInt(grandtot)) {
        let errMsg = "Paid Amount Must be Less than GrandTotalAmount";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (parseInt(paidAmt) <= 0) {
        let errMsg = "Paid Amount Must be Greater than Zero";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(checkData.expenseType)) {
        let errMsg = "ExpenseType is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(checkData.invoiceNumber)) {
        let errMsg = "Invoice is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl4: true,
      });
    } else {
      isValidData = true;
      this.setState({ isShowAlertLvl4: false });
    }
    return isValidData;
  };
  saveCheckTransactionVendorInvoiceLine = (e) => {
    if (e.detail == 1) {
      let checkTransactionData = this.state.checkTransactionData;
      let overAllInvLines = this.state.overAllInvLines;
      let invoiceLines = checkTransactionData.invoiceLines;
      let checkTransactionLineData = this.state.checkTransactionLineData;
      let inVoiceSortingLines = this.state.inVoiceSortingLines;
      let isValid = false;
      isValid = this.validateData(checkTransactionLineData);
      if (isValid) {
        var lineNumber = this.getCheckTransactionLineMaxLineNumber();
        let isLineFound = false;
        if (!isEmptyArray(invoiceLines)) {
          invoiceLines.map((line, i) => {
            if (line.invoiceNumber == checkTransactionLineData.invoiceNumber) {
              checkTransactionLineData.lineNumber = line.lineNumber;
              invoiceLines[i] = checkTransactionLineData;
              isLineFound = true;
            } else if (line.lineNumber == checkTransactionLineData.lineNumber) {
              invoiceLines[i] = checkTransactionLineData;
              isLineFound = true;
            }
          });
        }
        if (!isLineFound) {
          if (checkTransactionLineData.invoiceDiscountAmount == null) {
            checkTransactionLineData.invoiceDiscountAmount = 0;
          }
          checkTransactionLineData.lineNumber = ++lineNumber;
          invoiceLines.push(checkTransactionLineData);
        }
        overAllInvLines = invoiceLines;
        checkTransactionData.invoiceLines = overAllInvLines;
        inVoiceSortingLines = overAllInvLines;
        this.setState({
          checkTransactionData: checkTransactionData,
          isDisablePopupFields: true,
          inVoiceSortingLines: inVoiceSortingLines,
        });
        this.closeAlertModalCallBacklvl4(false);
        this.setTotalAmount(1);
      }
    }
  };
  clearCheckTransactionLineValues = (e) => {
    if (e.detail == 1) {
      let newLineBean = new CheckTransactionInvoiceLineBean();
      this.setState({
        checkTransactionLineData: newLineBean,
        overAllInvLines: [],
      });
    }
  };
  reArrangeCheckTransactionDisplayLineNumbers = (checkTransactionLineList) => {
    let maxLineNumber = 0;
    checkTransactionLineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  getCheckTransactionLineByLineNumber = (lineNumber) => {
    let chkTransLine = null;
    if (this.state.checkTransactionData === null) return chkTransLine;
    else if (this.state.checkTransactionData.invoiceLines == null)
      return chkTransLine;
    else {
      this.state.checkTransactionData.invoiceLines.map((line) => {
        if (line.lineNumber === lineNumber) {
          chkTransLine = line;
        }
      });
    }
    return chkTransLine;
  };
  getCheckTransactionInvoiceNumber = (invoiceNumber) => {
    let chkTransLine = null;
    if (this.state.checkTransactionData === null) return chkTransLine;
    else if (this.state.checkTransactionData.invoiceLines == null)
      return chkTransLine;
    else {
      this.state.checkTransactionData.invoiceLines.map((line) => {
        if (line.invoiceNumber === invoiceNumber) {
          chkTransLine = line;
        }
      });
    }
    return chkTransLine;
  };
  addInvoiceLines = (e) => {
    if (e.detail == 1) {
      let selectedInvoice = this.state.selectedInvoice;
      let checkTransactionData = this.state.checkTransactionData;
      let overAllInvLines = this.state.overAllInvLines;
      let tempInvoiceLine = [];
      let lineNumber = 0;
      selectedInvoice.map((ln, index) => {
        let lineBean = new CheckTransactionInvoiceLineBean();
        lineBean.lineNumber = ++lineNumber;
        lineBean.invoiceNumber = ln.code;
        lineBean.invoiceDescription = ln.description;
        lineBean.companyCode = this.companyCode;
        lineBean.invoiceDate = ln.invoiceDate;
        lineBean.invoiceDueDate = ln.invoiceDueDate;
        lineBean.invoiceGrandTotalAmount = ln.grandTotalAmount;
        lineBean.invoiceDiscountAmount = ln.discountAmount;
        lineBean.invoiceOpenAmount = ln.openAmount;
        lineBean.invoiceLinePaidAmount = ln.openAmount;
        lineBean.expenseType = ln.expenseType;
        lineBean.expenseSubType = ln.expenseSubType;
        lineBean.currencyCode = ln.currencyCode;
        overAllInvLines.push(lineBean);
      });
      checkTransactionData.invoiceLines = overAllInvLines;
      tempInvoiceLine = overAllInvLines;
      this.setState({
        checkTransactionData: checkTransactionData,
        isDisablePopupFields: true,
        inVoiceSortingLines: tempInvoiceLine,
      });
      this.closeAlertModalCallBacklvl3(false);
      this.setTotalAmount(1);
    }
  };
  deleteCheckTransactionVendorInvoiceLine = (line) => {
    let checkTransactionData = this.state.checkTransactionData;
    let invoiceLines = [];
    let lineData = checkTransactionData.invoiceLines;
    if (line.isFetched == false) {
      var index = lineData.indexOf(line);
      if (index > -1) {
        lineData.splice(index, 1);
      }
    } else {
    }
    checkTransactionData.invoiceLines = lineData;
    invoiceLines = checkTransactionData.invoiceLines;
    this.reArrangeCheckTransactionDisplayLineNumbers(lineData);
    this.setState({
      checkTransactionData: checkTransactionData,
      inVoiceSortingLines: invoiceLines,
    });
  };
  getCheckTransactionLineMaxLineNumber() {
    let maxLineNumber = 0;
    let invLineFormData = this.state.checkTransactionData.invoiceLines;
    if (invLineFormData.length > 0)
      invLineFormData.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  clearLocDetails = (e) => {
    if (e.detail == 1) {
      let newLineBean = new CheckTransactionLetterOfCreditLineBean();
      this.setState({
        letterOfCreditData: newLineBean,
      });
    }
  };
  readLOC = (code) => {
    let requestInput = new RestReadRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.code = code;
    if (SecurityAccessManager.CheckTransactionMaintenance_IsAccessible()) {
      AccountPayableService.readLetterOfCredit(
        requestInput,
        this.readLOCResponse,
        this.readLOCError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readLOCResponse = (response) => {
    if (response.data != null) {
      if (response.data.letterOfCreditBean != null) {
        let letterOfCredit_Data = response.data.letterOfCreditBean;
        let letterOfCreditData = new CheckTransactionLetterOfCreditLineBean();
        letterOfCreditData.companyCode = this.companyCode;
        letterOfCreditData.checkTransactionNumber =
          this.state.checkTransactionData.code;
        letterOfCreditData.bankCode = letterOfCredit_Data.bankCode;
        letterOfCreditData.bankName = letterOfCredit_Data.bankName;
        letterOfCreditData.letterOfCreditNumber =
          letterOfCredit_Data.letterOfCreditNumber;
        letterOfCreditData.letterOfCreditDate =
          letterOfCredit_Data.letterOfCreditDate;
        letterOfCreditData.letterOfCreditAmount =
          letterOfCredit_Data.letterOfCreditAmount;
        letterOfCreditData.transactionInformation =
          letterOfCredit_Data.transactionInformation;
        letterOfCreditData.currencyCode = "USD";
        let checkTransactionData = this.state.checkTransactionData;
        checkTransactionData.bankCode = letterOfCreditData.bankCode;
        checkTransactionData.bankName = letterOfCreditData.bankName;
        this.setState({
          letterOfCreditData: letterOfCreditData,
          checkTransactionData: checkTransactionData,
        });
      }
    }
  };
  readLOCError = (error) => {
    ShowError("Error : ", error);
  };
  clearMultiInvoices = () => {
    this.setState({
      selectedInvoice: [],
      availableInvoice: [],
      overAllInvLines: [],
    });
  };
  setTotalAmount = (type) => {
    let checkTransactionData = this.state.checkTransactionData;
    let totalAmount = 0;
    if (type == 1) {
      checkTransactionData.invoiceLines.map((ln) => {
        totalAmount += parseFloat(ln.invoiceLinePaidAmount);
      });
    } else if (type == 2) {
      checkTransactionData.letterOfCreditLines.map((ln) => {
        totalAmount += parseFloat(ln.letterOfCreditAmount);
      });
    }
    totalAmount = parseFloat(totalAmount).toFixed(2);
    checkTransactionData.totalAmount = totalAmount;
    checkTransactionData.standardTotalAmount = totalAmount;
    this.setState({
      checkTransactionData: checkTransactionData,
    });
  };
  transTypeOnChange = (e) => {
    let transactionType = e.target.value;
    this.state.isShowAutoCompleteTransTypeList = true;
    let tempData = this.state.checkTransactionData;
    let showAutoCompleteList = this.state.isShowAutoCompleteTransTypeList;
    if (isEmpty(transactionType)) {
      this.state.isShowAutoCompleteTransTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteTransTypeList;
      let tempData = this.state.checkTransactionData;
      tempData.transactionType = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        checkTransactionData: tempData,
        transTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "transactionType" &&
      showAutoCompleteList === true &&
      transactionType !== ""
    ) {
      this.readTransTypeBySearchString(e.target.value);
      this.readTransType(e.target.value);
      this.setTransactionType(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ checkTransactionData: tempData });
  };
  transTypeEnterKeyEvent = (e) => {
    this.readTransType(e.target.value);
    this.setTransactionType(e.target.value);
    this.state.isShowAutoCompleteTransTypeList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteTransTypeList;
    this.setState({
      transTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayTransTypeAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteTransTypeList: isShowAutoCompleteList,
    });
  };
  readTransTypeBySearchString = (searchString) => {
    let TransactionTypeData = this.state.transactionTypes;
    let simpleAutoCompleteList = new Array();
    if (TransactionTypeData.length > 0 && TransactionTypeData != null) {
      TransactionTypeData.map((obj) => {
        let TransactionTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(TransactionTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      transTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readTransType = (transactionType) => {
    let tempData = this.state.checkTransactionData;
    let TransactionTypeBean = null;
    let TransactionTypeData = null;
    this.state.transactionTypes.map((ln) => {
      if (ln.code === transactionType) {
        TransactionTypeBean = ln;
        TransactionTypeData = new BaseBean();
        TransactionTypeData.code = ln.code;
        TransactionTypeData.description = ln.description;
      }
    });
    if (!isEmpty(TransactionTypeBean)) {
      tempData.transactionType = TransactionTypeBean.code;
      this.state.isShowAutoCompleteTransTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteTransTypeList;
      this.setState({
        checkTransactionData: tempData,
        isShowAutoCompleteTransTypeList: showAutoCompleteList,
      });
    }
  };
  bankOnChange = (e) => {
    let bankCode = e.target.value;
    this.state.isShowAutoCompleteBankList = true;
    let tempData = this.state.checkTransactionData;
    let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
    if (isEmpty(bankCode)) {
      this.state.isShowAutoCompleteBankList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
      let tempData = this.state.checkTransactionData;
      tempData.bankCode = "";
      tempData.bankName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        checkTransactionData: tempData,
        bankPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "bankCode" &&
      showAutoCompleteList === true &&
      bankCode !== ""
    ) {
      this.readBankBySearchString(e.target.value);
      this.readBank(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ checkTransactionData: tempData });
  };
  bankEnterKeyEvent = (e) => {
    this.readBank(e.target.value);
    this.setBankDetails(e.target.value);
    this.state.isShowAutoCompleteBankList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
    this.setState({
      bankPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayBankAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteBankList: isShowAutoCompleteList,
    });
  };
  readBankBySearchString = (searchString) => {
    let bankData = this.state.banks;
    let simpleAutoCompleteList = new Array();
    if (bankData.length > 0 && bankData != null) {
      bankData.map((obj) => {
        let bankBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(bankBean);
      });
    }

    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      bankPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readBank = (bankCode) => {
    let tempData = this.state.checkTransactionData;
    let bankBean = null;
    let bankData = null;
    this.state.banks.map((ln) => {
      if (ln.code === bankCode) {
        bankBean = ln;
        bankData = new BaseBean();
        bankData.code = ln.code;
        bankData.description = ln.description;
      }
    });
    if (!isEmpty(bankBean)) {
      tempData.bankCode = bankBean.code;
      this.state.isShowAutoCompleteBankList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
      this.setState({
        checkTransactionData: tempData,
        isShowAutoCompleteBankList: showAutoCompleteList,
      });
    }
  };
  expenseTypeOnChange = (e) => {
    let expenseType = e.target.value;
    this.state.isShowAutoCompleteExpenseTypeList = true;
    let tempData = this.state.letterOfCreditData;
    let showAutoCompleteList = this.state.isShowAutoCompleteExpenseTypeList;
    if (isEmpty(expenseType)) {
      this.state.isShowAutoCompleteExpenseTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteExpenseTypeList;
      let tempData = this.state.letterOfCreditData;
      tempData.expenseType = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        letterOfCreditData: tempData,
        expenseTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "expenseType" &&
      showAutoCompleteList === true &&
      expenseType !== ""
    ) {
      this.readExpenseTypeBySearchString(e.target.value);
      this.readExpenseType(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ letterOfCreditData: tempData });
  };
  expenseTypeEnterKeyEvent = (e) => {
    this.readExpenseType(e.target.value);
    this.state.isShowAutoCompleteExpenseTypeList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteExpenseTypeList;
    this.setState({
      expenseTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayExpenseTypeAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteExpenseTypeList: isShowAutoCompleteList,
    });
  };
  readExpenseTypeBySearchString = (searchString) => {
    let expenseTypeData = this.state.expenseTypes;
    let simpleAutoCompleteList = new Array();
    if (expenseTypeData.length > 0 && expenseTypeData != null) {
      expenseTypeData.map((obj) => {
        let expenseTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(expenseTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      expenseTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readExpenseType = (expenseType) => {
    let tempData = this.state.letterOfCreditData;
    let expenseTypeBean = null;
    let expenseTypeData = null;
    this.state.expenseTypes.map((ln) => {
      if (ln.code === expenseType) {
        expenseTypeBean = ln;
        expenseTypeData = new BaseBean();
        expenseTypeData.code = ln.code;
        expenseTypeData.description = ln.description;
      }
    });
    if (!isEmpty(expenseTypeBean)) {
      tempData.expenseType = expenseTypeBean.code;
      this.state.isShowAutoCompleteExpenseTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteExpenseTypeList;
      this.setState({
        letterOfCreditData: tempData,
        isShowAutoCompleteExpenseTypeList: showAutoCompleteList,
      });
    }
  };
  expenseSubTypeOnChange = (e) => {
    let expenseSubType = e.target.value;
    this.state.isShowAutoCompleteExpenseSubTypeList = true;
    let tempData = this.state.letterOfCreditData;
    let showAutoCompleteList = this.state.isShowAutoCompleteExpenseSubTypeList;
    if (isEmpty(expenseSubType)) {
      this.state.isShowAutoCompleteExpenseSubTypeList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteExpenseSubTypeList;
      let tempData = this.state.letterOfCreditData;
      tempData.expenseSubType = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        letterOfCreditData: tempData,
        expenseSubTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "expenseSubType" &&
      showAutoCompleteList === true &&
      expenseSubType !== ""
    ) {
      this.readExpenseSubTypeBySearchString(e.target.value);
      this.readExpenseSubType(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ letterOfCreditData: tempData });
  };
  expenseSubTypeEnterKeyEvent = (e) => {
    this.readExpenseSubType(e.target.value);
    this.state.isShowAutoCompleteExpenseSubTypeList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteExpenseSubTypeList;
    this.setState({
      expenseSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayExpenseSubTypeAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteExpenseSubTypeList: isShowAutoCompleteList,
    });
  };
  readExpenseSubTypeBySearchString = (searchString) => {
    let expenseSubTypeData = this.state.expenseSubTypes;
    let simpleAutoCompleteList = new Array();
    if (expenseSubTypeData.length > 0 && expenseSubTypeData != null) {
      expenseSubTypeData.map((obj) => {
        let expenseSubTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(expenseSubTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      expenseSubTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readExpenseSubType = (expenseSubType) => {
    let tempData = this.state.letterOfCreditData;
    let expenseSubTypeBean = null;
    let expenseSubTypeData = null;
    this.state.expenseSubTypes.map((ln) => {
      if (ln.code === expenseSubType) {
        expenseSubTypeBean = ln;
        expenseSubTypeData = new BaseBean();
        expenseSubTypeData.code = ln.code;
        expenseSubTypeData.description = ln.description;
      }
    });
    if (!isEmpty(expenseSubTypeBean)) {
      tempData.expenseSubType = expenseSubTypeBean.code;
      this.state.isShowAutoCompleteExpenseSubTypeList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteExpenseSubTypeList;
      this.setState({
        letterOfCreditData: tempData,
        isShowAutoCompleteExpenseSubTypeList: showAutoCompleteList,
      });
    }
  };
  invExpenseTypeOnChange = (e) => {
    let expenseType = e.target.value;
    this.state.isShowAutoCompleteInvExpenseTypeList = true;
    let tempData = this.state.checkTransactionLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteInvExpenseTypeList;
    if (isEmpty(expenseType)) {
      this.state.isShowAutoCompleteInvExpenseTypeList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteInvExpenseTypeList;
      let tempData = this.state.checkTransactionLineData;
      tempData.expenseType = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        checkTransactionLineData: tempData,
        invExpenseTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "expenseType" &&
      showAutoCompleteList === true &&
      expenseType !== ""
    ) {
      this.readInvExpenseTypeBySearchString(e.target.value);
      this.readInvExpenseType(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ checkTransactionLineData: tempData });
  };
  invExpenseTypeEnterKeyEvent = (e) => {
    this.readInvExpenseType(e.target.value);
    this.state.isShowAutoCompleteInvExpenseTypeList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteInvExpenseTypeList;
    this.setState({
      invExpenseTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayInvExpenseTypeAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteInvExpenseTypeList: isShowAutoCompleteList,
    });
  };
  readInvExpenseTypeBySearchString = (searchString) => {
    let expenseTypeData = this.state.expenseTypes;
    let simpleAutoCompleteList = new Array();
    if (expenseTypeData.length > 0 && expenseTypeData != null) {
      expenseTypeData.map((obj) => {
        let expenseTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(expenseTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      invExpenseTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readInvExpenseType = (expenseType) => {
    let tempData = this.state.checkTransactionLineData;
    let expenseTypeBean = null;
    let expenseTypeData = null;
    this.state.expenseTypes.map((ln) => {
      if (ln.code === expenseType) {
        expenseTypeBean = ln;
        expenseTypeData = new BaseBean();
        expenseTypeData.code = ln.code;
        expenseTypeData.description = ln.description;
      }
    });
    if (!isEmpty(expenseTypeBean)) {
      tempData.expenseType = expenseTypeBean.code;
      this.state.isShowAutoCompleteInvExpenseTypeList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteInvExpenseTypeList;
      this.setState({
        checkTransactionLineData: tempData,
        isShowAutoCompleteInvExpenseTypeList: showAutoCompleteList,
      });
    }
  };
  invExpenseSubTypeOnChange = (e) => {
    let expenseSubType = e.target.value;
    this.state.isShowAutoCompleteInvExpenseSubTypeList = true;
    let tempData = this.state.checkTransactionLineData;
    let showAutoCompleteList =
      this.state.isShowAutoCompleteInvExpenseSubTypeList;
    if (isEmpty(expenseSubType)) {
      this.state.isShowAutoCompleteInvExpenseSubTypeList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteInvExpenseSubTypeList;
      let tempData = this.state.checkTransactionLineData;
      tempData.expenseSubType = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        checkTransactionLineData: tempData,
        invExpenseSubTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "expenseSubType" &&
      showAutoCompleteList === true &&
      expenseSubType !== ""
    ) {
      this.readInvExpenseSubTypeBySearchString(e.target.value);
      this.readInvExpenseSubType(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ checkTransactionLineData: tempData });
  };
  invExpenseSubTypeEnterKeyEvent = (e) => {
    this.readInvExpenseSubType(e.target.value);
    this.state.isShowAutoCompleteInvExpenseSubTypeList = false;
    let showAutoCompleteList =
      this.state.isShowAutoCompleteInvExpenseSubTypeList;
    this.setState({
      invExpenseSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayInvExpenseSubTypeAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteInvExpenseSubTypeList: isShowAutoCompleteList,
    });
  };
  readInvExpenseSubTypeBySearchString = (searchString) => {
    let expenseSubTypeData = this.state.expenseSubTypes;
    let simpleAutoCompleteList = new Array();
    if (expenseSubTypeData.length > 0 && expenseSubTypeData != null) {
      expenseSubTypeData.map((obj) => {
        let expenseSubTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(expenseSubTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      invExpenseSubTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readInvExpenseSubType = (expenseSubType) => {
    let tempData = this.state.checkTransactionLineData;
    let expenseSubTypeBean = null;
    let expenseSubTypeData = null;
    this.state.expenseSubTypes.map((ln) => {
      if (ln.code === expenseSubType) {
        expenseSubTypeBean = ln;
        expenseSubTypeData = new BaseBean();
        expenseSubTypeData.code = ln.code;
        expenseSubTypeData.description = ln.description;
      }
    });
    if (!isEmpty(expenseSubTypeBean)) {
      tempData.expenseSubType = expenseSubTypeBean.code;
      this.state.isShowAutoCompleteInvExpenseSubTypeList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteInvExpenseSubTypeList;
      this.setState({
        checkTransactionLineData: tempData,
        isShowAutoCompleteInvExpenseSubTypeList: showAutoCompleteList,
      });
    }
  };
  currencyOnChange = (e) => {
    let currencyCode = e.target.value;
    this.state.isShowAutoCompleteCurrencyList = true;
    let tempData = this.state.checkTransactionLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCurrencyList;
    if (isEmpty(currencyCode)) {
      this.state.isShowAutoCompleteCurrencyList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCurrencyList;
      let tempData = this.state.checkTransactionLineData;
      tempData.currencyCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        checkTransactionLineData: tempData,
        currencyPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "currencyCode" &&
      showAutoCompleteList === true &&
      currencyCode !== ""
    ) {
      this.readCurrencyBySearchString(e.target.value);
      this.readCurrency(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ checkTransactionLineData: tempData });
  };
  currencyEnterKeyEvent = (e) => {
    this.readCurrency(e.target.value);
    this.state.isShowAutoCompleteCurrencyList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCurrencyList;
    this.setState({
      currencyPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayCurrencyAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCurrencyList: isShowAutoCompleteList,
    });
  };
  readCurrencyBySearchString = (searchString) => {
    let currencyData = this.state.currencies;
    let simpleAutoCompleteList = new Array();
    if (currencyData.length > 0 && currencyData != null) {
      currencyData.map((obj) => {
        let currencyBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(currencyBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      currencyPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readCurrency = (currencyCode) => {
    let tempData = this.state.checkTransactionLineData;
    let currencyBean = null;
    let currencyData = null;
    this.state.currencies.map((ln) => {
      if (ln.code === currencyCode) {
        currencyBean = ln;
        currencyData = new BaseBean();
        currencyData.code = ln.code;
        currencyData.description = ln.description;
      }
    });
    if (!isEmpty(currencyBean)) {
      tempData.currencyCode = currencyBean.code;
      this.state.isShowAutoCompleteCurrencyList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCurrencyList;
      this.setState({
        checkTransactionLineData: tempData,
        isShowAutoCompleteCurrencyList: showAutoCompleteList,
      });
    }
  };
  onVendorInvoiceChange = (e) => {
    let vendorInvoiceCode = e.target.value;
    this.state.isShowAutoCompleteVendorInvoiceList = true;
    let tempData = this.state.checkTransactionLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteVendorInvoiceList;
    if (isEmpty(vendorInvoiceCode)) {
      this.state.isShowAutoCompleteVendorInvoiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteVendorInvoiceList;
      let tempData = this.state.checkTransactionLineData;
      tempData.invoiceNumber = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteVendorInvoiceList: showAutoCompleteList,
        checkTransactionLineData: tempData,
        vendorInvoicePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "invoiceNumber" &&
      showAutoCompleteList === true &&
      vendorInvoiceCode !== ""
    ) {
      this.readVendorInvoiceBySearchString(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({
      checkTransactionLineData: tempData,
    });
  };
  vendorInvoiceEnterKeyEventHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading vendorInvoice",
    });
    this.readVendorInvoice(e.target.value);
    this.state.isShowAutoCompleteVendorInvoiceList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteVendorInvoiceList;
    this.setState({
      vendorInvoicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteVendorInvoiceList: showAutoCompleteList,
    });
  };
  displayVendorInvoiceAutoCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteVendorInvoiceList: showAutoCompleteList,
    });
  };
  readVendorInvoiceBySearchString(searchString) {
    let searchCriteria = new VendorInvoiceSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorInvoiceCode = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorInvoiceListRequest();
    input.searchCriteria = searchCriteria;
    input.pageInput = pageList;
    if (SecurityAccessManager.CheckTransactionMaintenance_IsAccessible()) {
      AccountPayableService.getVendorInvoices(
        input,
        this.readByVendorInvoiceCodeResponse,
        this.readByVendorInvoiceCodeResponseError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }
  readByVendorInvoiceCodeResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.vendorInvoicePageList) &&
      !isEmpty(response.data.vendorInvoicePageList.vendorInvoices)
    ) {
      let vendorInvoiceCodeData =
        response.data.vendorInvoicePageList.vendorInvoices;
      let simpleAutoCompleteList = new Array();
      if (vendorInvoiceCodeData.length > 0 && vendorInvoiceCodeData != null) {
        vendorInvoiceCodeData.map((vendorInvoiceCode) => {
          let simpleItemBean = {
            code: vendorInvoiceCode.code,
            description: "",
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        vendorInvoicePageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  readByVendorInvoiceCodeResponseError = (error) => {
    ShowError("Error : ", error);
  };
  onLetterCreditCodeChange = (e) => {
    let letterOfCreditCode = e.target.value;
    this.state.isShowAutoCompleteLetterOfCreditList = true;
    let tempData = this.state.letterOfCreditData;
    let showAutoCompleteList = this.state.isShowAutoCompleteLetterOfCreditList;
    if (isEmpty(letterOfCreditCode)) {
      this.state.isShowAutoCompleteLetterOfCreditList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteLetterOfCreditList;
      let tempData = this.state.letterOfCreditData;
      tempData.letterOfCreditNumber = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteLetterOfCreditList: showAutoCompleteList,
        letterOfCreditData: tempData,
        letterOfCreditPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "letterOfCreditNumber" &&
      showAutoCompleteList === true &&
      letterOfCreditCode !== ""
    ) {
      this.readLetterOfCreditBySearchString(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({
      letterOfCreditData: tempData,
    });
  };
  letterOfCreditEnterKeyEventHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading letterOfCredit",
    });
    this.readLOC(e.target.value);
    this.state.isShowAutoCompleteLetterOfCreditList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteLetterOfCreditList;
    this.setState({
      letterOfCreditPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLetterOfCreditList: showAutoCompleteList,
    });
  };
  displayLetterOfCreditAutoCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteLetterOfCreditList: showAutoCompleteList,
    });
  };
  readLetterOfCreditBySearchString(searchString) {
    let searchCriteria = new LetterOfCreditSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.letterOfCreditNumberStartsWith = searchString;
    searchCriteria.letterOfCreditNumberContains = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestLetterOfCreditListRequest();
    input.searchCriteria = searchCriteria;
    input.pageInput = pageList;
    if (SecurityAccessManager.CheckTransactionMaintenance_IsAccessible()) {
      AccountPayableService.getLetterOfCreditPageList(
        input,
        this.readByLetterOfCreditCodeResponse,
        this.readByLetterOfCreditCodeResponseError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }
  readByLetterOfCreditCodeResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.pageList) &&
      !isEmpty(response.data.pageList.letterOfCredits)
    ) {
      let letterOfCreditCodeData = response.data.pageList.letterOfCredits;
      let simpleAutoCompleteList = new Array();
      if (letterOfCreditCodeData.length > 0 && letterOfCreditCodeData != null) {
        letterOfCreditCodeData.map((letterOfCreditCode) => {
          let simpleItemBean = {
            code: letterOfCreditCode.letterOfCreditNumber,
            description: "",
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        letterOfCreditPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  readByLetterOfCreditCodeResponseError = (error) => {
    ShowError("Error : ", error);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let check_transaction_list = this.state.check_transaction_list;
    if (sortField && !isEmptyArray(check_transaction_list)) {
      const sorted = [...check_transaction_list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ check_transaction_list: sorted });
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowLocModule: isOpen,
      moduleForPopup: [],
    });
  };

  viewLocModule = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowLocModule: true,
        moduleForPopup: (
          <PopupLocModule code={code} onModuleExit={this.onPopupModalExit} />
        ),
      });
    }
  };

  closeAlertModalCallBacklvl3 = (isShowPopup) => {
    this.setState({
      isShowMultiInvoicePopup: isShowPopup,
      isShowAlertLvl3: isShowPopup,
    });
    this.clearMultiInvoices();
  };
  closeAlertModalCallBacklvl4 = (isShowPopup) => {
    this.setState({
      isShowInvoicePopup: isShowPopup,
      isShowAlertLvl4: isShowPopup,
      isShowAutoCompleteVendorInvoiceList: false,
      vendorInvoicePageListForAutoCompleteList: new Array(),

      checkTransactionLineData: new CheckTransactionInvoiceLineBean(),
      overAllInvLines: [],
    });
    // this.clearCheckTransactionLineValues();
  };
  closeAlertModalCallBacklvl5 = (isShowPopup) => {
    this.setState({
      isShowPrintPopup: isShowPopup,
      isShowLocPopup: isShowPopup,
      isShowAlertLvl5: isShowPopup,

      letterOfCreditData: new CheckTransactionLetterOfCreditLineBean(),
    });
    // this.clearLocDetails();
  };
  hideAlertCallBackLvl3 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl4: isDisplayed });
  };
  hideAlertCallBackLvl4 = (msgType, isDisplayed) => {
    this.setState({
      isShowAlertLvl4: isDisplayed,
    });
  };
  hideAlertCallBackLvl5 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl5: isDisplayed });
  };
  addressClickHandler = (e) => {
    if (e.detail == 1) {
      let checkTransactionData = this.state.checkTransactionData;
      let addressData = new AddressBean();
      addressData = { ...checkTransactionData.address };
      this.setState({ isShowAddressPopup: true, addressData: addressData });
    }
  };
  closeAlertAddressModalCallBack = () => {
    this.setState({
      isShowAddressPopup: false,
      addressData: new AddressBean(),
    });
  };
  addressOnChange = (e) => {
    let addressData = this.state.addressData;
    addressData[e.target.name] = e.target.value;
    this.setState({ addressData: addressData });
  };
  addressOnClick = () => {
    let checkTransactionData = this.state.checkTransactionData;
    let addressData = { ...this.state.addressData };
    checkTransactionData.address = addressData;
    this.setState({ checkTransactionData: checkTransactionData });
    this.closeAlertAddressModalCallBack();
  };
  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let checkTransactionData = this.state.checkTransactionData;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let addressData = this.state.addressData;
      addressData.city = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCityList: showAutoCompleteList,
        addressData: addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readCityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let cityList = this.state.cityList;
      cityList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["city"] = pdtType.code;
          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteCityList: showAutoCompleteList });
        }
      });
    }
    this.setState({
      checkTransactionData: checkTransactionData,
      addressData: temp_addressData,
    });
  };
  readCityBySearchString(searchString) {
    let cityData = this.state.cityList;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEventHandler = (e) => {
    let city = e.target.value;
    let city_List = this.state.cityList;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;
      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };

  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;

    let temp_addressData = this.state.addressData;

    let showAutoCompleteList = this.state.showAutoCompleteStateList;
    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let addressData = this.state.addressData;

      addressData.state = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteStateList: showAutoCompleteList,
        addressData: addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readStateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let stateList = this.state.stateList;
      stateList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["state"] = pdtType.code;
          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteStateList: showAutoCompleteList });
        }
      });
    }

    this.setState({
      addressData: temp_addressData,
    });
  };
  readStateBySearchString(searchString) {
    let stateData = this.state.stateList;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEventHandler = (e) => {
    let state = e.target.value;
    let state_List = this.state.stateList;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;

      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };
  onCountryChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryList = true;

    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryList;
      let addressData = this.state.addressData;
      addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCountryList: showAutoCompleteList,
        addressData: addressData,
        countryPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readCountryBySearchString(country);
    }
    if (e.target.name == "country") {
      temp_addressData["country"] = e.target.value;
      let countryList = this.state.countryList;
      countryList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["country"] = pdtType.code;
          this.state.showAutoCompleteCountryList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryList;
          this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
        }
      });
    }
    this.setState({
      addressData: temp_addressData,
    });
  };
  readCountryBySearchString(searchString) {
    let stateData = this.state.countryList;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ countryPageListForAutoCompleteList: filteredSuggestions });
  }
  countryEnterKeyEventHandler = (e) => {
    let country = e.target.value;
    let country_List = this.state.countryList;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.country = countryBean.code;
      this.setState({
        addressData: temp_addressData,
        countryPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCountryList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
  };

  handleSortingInvoiveLineChange = (e, accessor) => {
    if (e.detail == 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingInvoiceLine(sortField, sortOrder);
    }
  };
  handleSortingInvoiceLine = (sortField, sortOrder) => {
    let list = this.state.availableInvoice;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ availableInvoice: sorted });
    }
  };

  handleSortingInvoiveLineSelectedChange = (e, accessor) => {
    if (e.detail == 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingInvoiceLineSelected(sortField, sortOrder);
    }
  };
  handleSortingInvoiceLineSelected = (sortField, sortOrder) => {
    let list = this.state.selectedInvoice;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ selectedInvoice: sorted });
    }
  };

  handleSortingStatusTrackChange = (e, accessor) => {
    if (e.detail == 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingStatusTrack(sortField, sortOrder);
    }
  };
  handleSortingStatusTrack = (sortField, sortOrder) => {
    let list = this.state.statusTracksList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ statusTracksList: sorted });
    }
  };

  handleSortingPrintHistoriesChange = (e, accessor) => {
    if (e.detail == 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingPrintedHistory(sortField, sortOrder);
    }
  };
  handleSortingPrintedHistory = (sortField, sortOrder) => {
    let list = this.state.printHistoriesList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ printHistoriesList: sorted });
    }
  };

  handleSortingInvoiceLineSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingInvoiceTableSorting(sortField, sortOrder);
  };
  handleSortingInvoiceTableSorting = (sortField, sortOrder) => {
    let list = this.state.inVoiceSortingLines;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });

      this.setState({ inVoiceSortingLines: sorted });
    }
  };

  handleSortingLocLineChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingLocLineListChange(sortField, sortOrder);
  };
  handleSortingLocLineListChange = (sortField, sortOrder) => {
    let list = this.state.locLineList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });

      this.setState({ locLineList: sorted });
    }
  };
  glAccountForm = () => {
    let criteria = this.state.glAccountLinedata;
    criteria.checkTransactionNumber = "NEW";
    this.setState({
      isShowGlAccountPopup: true,
      glAccountLinedata: criteria,
    });
  };

  closeAlertModalCallBacklvl6 = (isShowPopup) => {
    this.setState({
      isShowGlAccountPopup: isShowPopup,
      isShowAlertLvl6: isShowPopup,
      glAccountLinedata: new CheckTransactionGLAccountAppliedAmountBean(),
    });
  };
  hideAlertCallBackLvl6 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl6: isDisplayed });
  };
  onGlAccountChange = (e) => {
    let criteria = this.state.glAccountLinedata;
    criteria[e.target.name] = e.target.value;
    this.setState({ glAccountLinedata: criteria });
  };
  addGlAccountLines = (e) => {
    if (e.detail === 1) {
      let checkTransactionData = this.state.checkTransactionData;
      let glAccountData = this.state.glAccountLinedata;
      if (!isEmptyString(glAccountData.glAccountNumber)) {
        glAccountData.companyCode = this.companyCode;
        let isLineFound = false;
        let glAccountLineDetails = [];
        glAccountLineDetails = checkTransactionData.glAppliedAmounts;
        if (!isEmptyArray(glAccountLineDetails)) {
          glAccountLineDetails.map((line, i) => {
            if (line.glAccountNumber == glAccountData.glAccountNumber) {
              glAccountLineDetails[i] = glAccountData;
              isLineFound = true;
            } else if (isLineFound == false) {
              isLineFound = true;
              glAccountLineDetails.push(glAccountData);
            }
          });
        } else {
          glAccountLineDetails.push(glAccountData);
        }
        checkTransactionData.glAppliedAmounts = glAccountLineDetails;
        this.setState({
          glAccountLines: glAccountLineDetails,
          checkTransactionData: checkTransactionData,
          isShowGlAccountPopup: false,
          glAccountLinedata: new CheckTransactionGLAccountAppliedAmountBean(),
        });
      } else {
        let errMsg = "glAccountNumber is Required...!";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlertLvl6: true,
        });
      }
    }
  };
  editGlAccountLineDetail = (rowData) => {
    let glAccountLinedata = { ...rowData };
    this.setState({
      glAccountLinedata: glAccountLinedata,
      isShowGlAccountPopup: true,
    });
  };
  deleteGlAccountLine = (line) => {
    let checkTransactionData = this.state.checkTransactionData;
    let glAppliedAmounts = checkTransactionData.glAppliedAmounts;
    let glAccountLines = this.state.glAccountLines;
    glAppliedAmounts.map((list, index) => {
      if (list.glAccountNumber === line) {
        glAppliedAmounts.splice(index, 1);
      }
    });
    checkTransactionData.glAppliedAmounts = glAppliedAmounts;
    glAccountLines = glAppliedAmounts;
    this.setState({
      checkTransactionData: checkTransactionData,
      glAccountLines: glAccountLines,
    });
  };
  handleSortingGLChange = () => {};
  handleSortingGLChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingGLAccountChange(sortField, sortOrder);
  };
  handleSortingGLAccountChange = (sortField, sortOrder) => {
    let list = this.state.glAccountLines;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });

      this.setState({ glAccountLines: sorted });
    }
  };
  render() {
    let checkTransactionData = this.state.checkTransactionData;
    if (checkTransactionData.address == null) {
      checkTransactionData.address = new AddressBean();
    }
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let letterOfCreditData = this.state.letterOfCreditData;
    let checkTransactionLineData = this.state.checkTransactionLineData;
    let glAccountLinedata = this.state.glAccountLinedata;
    let isDisableBasedOnManual = false;
    if (checkTransactionData.isFetched) {
      if (
        checkTransactionData.status ==
        LogicConstants.CHECK_TRANSACTION_VOIDED_STATUS
      ) {
        isDisableBasedOnManual = true;
      }
    }
    return (
      <div>
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          pageTitle={this.state.pageTitle}
          resetView={() => this.resetView()}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editCheckTransaction}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.checkTransactionLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
        />
        {this.state.isCheckTransactionEntryFormOpen &&
          this.state.isViewMode == false && (
            <BaseToolBar
              extend_toolbar={
                <CheckTransactionToolBar
                  approveCheckTransaction={this.approveCheckTransaction}
                  cancelCheckTransaction={this.cancelCheckTransaction}
                  printCheckTransaction={this.printCheckTransaction}
                  isShowPrintButton={this.state.isShowPrintButton}
                  isShowRePrintButton={this.state.isShowRePrintButton}
                  isShowApproveButton={this.state.isShowApproveButton}
                  isShowCancelButton={this.state.isShowCancelButton}
                />
              }
              save={this.save}
              clearError={this.clearError}
              generatePDF={this.generatePDF}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              isShowPDFButton={this.state.isShowPDFReportButton}
              pageTitle={this.state.pageTitle}
              isShowModuleSearchContainer={
                this.state.isShowModuleSearchContainer
              }
              onModuleKeyContainerButtonClick={this.editCheckTransaction}
              moduleKeyCode={this.state.moduleKeyCode}
              onModuleKeyCodeChange={this.onModuleKeyCodeChange}
            />
          )}
        {/* <BaseNotification error_list={this.state.error_list} /> */}
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedNodeKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={moduleOrderStatus}
          />
        )}
        {!this.state.isShowNodes &&
          !this.state.isCheckTransactionListFormOpen &&
          !this.state.isCheckTransactionHistoryFormOpen &&
          this.state.isCheckTransactionEntryFormOpen}
        {this.state.isShowNodes &&
          !this.state.isCheckTransactionListFormOpen &&
          !this.state.isCheckTransactionHistoryFormOpen &&
          this.state.isCheckTransactionEntryFormOpen}
        {this.state.isShowNodes &&
          !this.state.isCheckTransactionListFormOpen &&
          this.state.isCheckTransactionHistoryFormOpen &&
          !this.state.isCheckTransactionEntryFormOpen &&
          this.getHistoryView()}
        {this.state.isCheckTransactionListFormOpen && (
          <CheckTransactionListForm
            {...this.state}
            filterCheckTransaction={this.filterCheckTransaction}
            loadFirst={this.loadFirst}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
            loadLast={this.loadLast}
            editCheckTransaction={this.editCheckTransaction}
            resetCheckTransaction={this.resetfilteredCheckTransaction}
            listFormOnChange={this.listFormOnChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}
        {this.state.isCheckTransactionEntryFormOpen && (
          <CheckTransactionEntryForm
            {...this.state}
            onChange={this.onChange}
            onVendorCodeChange={this.onVendorCodeChange}
            openMultipleInvoiceForm={this.openMultipleInvoiceForm}
            getChecktransactionInvoiceLineDetails={
              this.getChecktransactionInvoiceLineDetails
            }
            deleteCheckTransactionVendorInvoiceLine={
              this.deleteCheckTransactionVendorInvoiceLine
            }
            openInvoiceForm={this.openInvoiceForm}
            openLetterOfCreditForm={this.openLetterOfCreditForm}
            deleteLOCLine={this.deleteLOCLine}
            getLocLineDetails={this.getLocLineDetails}
            transTypeOnChange={this.transTypeOnChange}
            transTypeEnterKeyEvent={this.transTypeEnterKeyEvent}
            displayTransTypeAutoCompleteList={
              this.displayTransTypeAutoCompleteList
            }
            bankOnChange={this.bankOnChange}
            bankEnterKeyEvent={this.bankEnterKeyEvent}
            displayBankAutoCompleteList={this.displayBankAutoCompleteList}
            vendorCodeEnterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
            displayVendorAutoCompleteList={this.displayVendorAutoCompleteList}
            viewLocModule={this.viewLocModule}
            addressClickHandler={this.addressClickHandler}
            handleSortingInvoiceLineSortingChange={
              this.handleSortingInvoiceLineSortingChange
            }
            handleSortingLocLineChange={this.handleSortingLocLineChange}
            glAccountForm={this.glAccountForm}
            editGlAccountLineDetail={this.editGlAccountLineDetail}
            deleteGlAccountLine={this.deleteGlAccountLine}
            handleSortingGLChange={this.handleSortingGLChange}
          />
        )}
        <AddressComponent
          {...this.state}
          isShowPopup={this.state.isShowAddressPopup}
          title={"Address"}
          closeAlertAddressModalCallBack={this.closeAlertAddressModalCallBack}
          onChange={this.addressOnChange}
          onClick={this.addressOnClick}
          disabled={this.state.isVoided}
          onCityChange={this.onCityChange}
          cityEnterKeyEventHandler={this.cityEnterKeyEventHandler}
          displayAutoCompleteCityList={this.displayAutoCompleteCityList}
          onStateChange={this.onStateChange}
          stateEnterKeyEventHandler={this.stateEnterKeyEventHandler}
          displayAutoCompleteStateList={this.displayAutoCompleteStateList}
          onCountryChange={this.onCountryChange}
          countryEnterKeyEventHandler={this.countryEnterKeyEventHandler}
          displayAutoCompleteCountryList={this.displayAutoCompleteCountryList}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowLocModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel5"}
          isModulePopup={false}
          isShowPopup={this.state.isShowLocPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl5}
          title={"Letter Of Credit Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl5}
              hideAlertCallBack={this.hideAlertCallBackLvl5}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                type="submit"
                bssize="sm"
                disabled={this.state.isDisabledFields}
                onClick={(e) => this.addLetterOfCredit(e)}
              >
                Add/UpDate
              </Button>

              <Button
                className="header_buttons enterFocus"
                type="submit"
                bssize="sm"
                disabled={this.state.isDisabledFields}
                onClick={(e) => this.clearLocDetails(e)}
              >
                Clear{" "}
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">
                    CheckTransaction#
                  </FormLabel>
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.onLetterCreditChange}
                    name="code"
                    value={checkTransactionData.code}
                    disabled={true}
                  />
                </Col>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">LineNumber</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.onLetterCreditChange}
                    disabled={true}
                    name="lineNumber"
                    value={letterOfCreditData.lineNumber}
                  ></InputTextbox>
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">
                    LetterOfCredit
                  </FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    ref={this.locRef}
                    onChange={this.onLetterCreditCodeChange}
                    disabled={this.state.isDisablePopupFields}
                    name="letterOfCreditNumber"
                    value={letterOfCreditData.letterOfCreditNumber}
                    lookupRequired={true}
                    lookupHandler={this.state.letterOfCreditLookupHandler}
                    enterKeyEventHandler={
                      this.letterOfCreditEnterKeyEventHandler
                    }
                    autoCompleteListData={
                      this.state.letterOfCreditPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayLetterOfCreditAutoCompleteList
                    }
                    showAutoCompleteList={
                      this.state.isShowAutoCompleteLetterOfCreditList
                    }
                  ></InputTextbox>
                </Col>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">LOC Date</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <DatePickerComponent
                    onChange={this.onLetterCreditChange}
                    disabled={true}
                    name="letterOfCreditDate"
                    value={letterOfCreditData.letterOfCreditDate}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">Amount</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <NumberFormatInputbox
                    onChange={this.onLetterCreditChange}
                    disabled={this.state.isDisablePopupFields}
                    name="letterOfCreditAmount"
                    decimalScale={2}
                    value={letterOfCreditData.letterOfCreditAmount}
                  />
                </Col>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">BankCode</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    placeholder="Enter bankCode"
                    onChange={this.onLetterCreditChange}
                    disabled={true}
                    name="bankCode"
                    value={letterOfCreditData.bankCode}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">BankName</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.onLetterCreditChange}
                    disabled={true}
                    name="bankName"
                    value={letterOfCreditData.bankName}
                  />
                </Col>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">ExpenseType</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.expenseTypeOnChange}
                    placeholder="expenseType"
                    name="expenseType"
                    value={letterOfCreditData.expenseType}
                    lookupRequired={true}
                    lookupHandler={this.state.expenseTypeLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.expenseTypeEnterKeyEvent}
                    autoCompleteListData={
                      this.state.expenseTypePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayExpenseTypeAutoCompleteList
                    }
                    showAutoCompleteList={
                      this.state.isShowAutoCompleteExpenseTypeList
                    }
                    disabled={this.state.isDisablePopupFields}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel>ExpenseSubType</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.expenseSubTypeOnChange}
                    placeholder="expenseSubType"
                    name="expenseSubType"
                    value={letterOfCreditData.expenseSubType}
                    lookupRequired={true}
                    lookupHandler={this.state.expenseSubTypeLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.expenseSubTypeEnterKeyEvent}
                    autoCompleteListData={
                      this.state.expenseSubTypePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayExpenseSubTypeAutoCompleteList
                    }
                    showAutoCompleteList={
                      this.state.isShowAutoCompleteExpenseSubTypeList
                    }
                    disabled={this.state.isDisablePopupFields}
                  />
                </Col>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">Transaction</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.onLetterCreditChange}
                    disabled={this.state.isDisablePopupFields}
                    name="transactionInformation"
                    value={letterOfCreditData.transactionInformation}
                  />
                </Col>
              </Row>
            </div>
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowMultiInvoicePopup}
          closeOnEsc={true}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl3}
          title={"VendorInvoice selectionEntry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl3}
              hideAlertCallBack={this.hideAlertCallBackLvl3}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.addInvoiceLines(e)}
                // disabled={this.state.isDisabledFields}
              >
                Add/Update
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col sm="2">
                  <FormLabel>Check Transaction</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    readOnly={true}
                    disabled={true}
                    name="code"
                    value={checkTransactionData.code}
                  ></InputTextbox>
                </Col>
              </Row>
              <div className="div_Custom_3">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th></th>
                      <th
                        onClick={(e) =>
                          this.handleSortingInvoiveLineChange(e, "code")
                        }
                      >
                        Invoice
                        {this.state.order === "desc" &&
                        this.state.sortField === "code" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingInvoiveLineChange(e, "invoiceDate")
                        }
                      >
                        InvoiceDate
                        {this.state.order === "desc" &&
                        this.state.sortField === "invoiceDate" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingInvoiveLineChange(
                            e,
                            "invoiceDueDate"
                          )
                        }
                      >
                        DueDate
                        {this.state.order === "desc" &&
                        this.state.sortField === "invoiceDueDate" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingInvoiveLineChange(
                            e,
                            "grandTotalAmount"
                          )
                        }
                      >
                        TotalAmt
                        {this.state.order === "desc" &&
                        this.state.sortField === "grandTotalAmount" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingInvoiveLineChange(e, "paidAmount")
                        }
                      >
                        PaidAmt
                        {this.state.order === "desc" &&
                        this.state.sortField === "paidAmount" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingInvoiveLineChange(e, "openAmount")
                        }
                      >
                        AmtDue
                        {this.state.order === "desc" &&
                        this.state.sortField === "openAmount" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    </tr>
                  </thead>
                  {!isEmptyArray(this.state.availableInvoice) && (
                    <tbody>
                      {this.state.availableInvoice.map((ln, index) => (
                        <tr key={index}>
                          <td>
                            <Button
                              variant="secondry"
                              onClick={(e) =>
                                this.selectVendorInvoice(e, ln.code, ln)
                              }
                            >
                              <AddIcon />
                            </Button>
                          </td>
                          <td>{ln.code}</td>
                          <td>{ln.invoiceDate}</td>
                          <td>{ln.invoiceDueDate}</td>
                          <td className="text-right">{ln.grandTotalAmount}</td>
                          <td className="text-right">{ln.paidAmount}</td>
                          <td className="text-right">{ln.openAmount}</td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
                {this.state.availableInvoice.length != 0 ? null : (
                  <div className="no_Data_small">{"NO DATA"}</div>
                )}
              </div>
              <div className="div_Custom_3">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th></th>
                      <th
                        onClick={(e) =>
                          this.handleSortingInvoiveLineSelectedChange(e, "code")
                        }
                      >
                        Invoice
                        {this.state.order === "desc" &&
                        this.state.sortField === "code" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingInvoiveLineSelectedChange(
                            e,
                            "invoiceDate"
                          )
                        }
                      >
                        InvoiceDate
                        {this.state.order === "desc" &&
                        this.state.sortField === "invoiceDate" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingInvoiveLineSelectedChange(
                            e,
                            "invoiceDueDate"
                          )
                        }
                      >
                        DueDate
                        {this.state.order === "desc" &&
                        this.state.sortField === "invoiceDueDate" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingInvoiveLineSelectedChange(
                            e,
                            "grandTotalAmount"
                          )
                        }
                      >
                        TotalAmt
                        {this.state.order === "desc" &&
                        this.state.sortField === "grandTotalAmount" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingInvoiveLineSelectedChange(
                            e,
                            "paidAmount"
                          )
                        }
                      >
                        PaidAmt
                        {this.state.order === "desc" &&
                        this.state.sortField === "paidAmount" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingInvoiveLineSelectedChange(
                            e,
                            "openAmount"
                          )
                        }
                      >
                        AmtDue
                        {this.state.order === "desc" &&
                        this.state.sortField === "openAmount" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    </tr>
                  </thead>
                  {!isEmptyArray(this.state.selectedInvoice) && (
                    <tbody>
                      {this.state.selectedInvoice.map((ln) => (
                        <tr>
                          <td>
                            <Button
                              variant="secondry"
                              onClick={(e) =>
                                this.unSelectVendorInvoice(e, ln.code, ln)
                              }
                            >
                              <CancelIcon />
                            </Button>
                          </td>
                          <td>{ln.code}</td>
                          <td>{ln.invoiceDate}</td>
                          <td>{ln.invoiceDueDate}</td>
                          <td className="text-right">{ln.grandTotalAmount}</td>
                          <td className="text-right">{ln.paidAmount}</td>
                          <td className="text-right">{ln.openAmount}</td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
                {this.state.selectedInvoice.length != 0 ? null : (
                  <div className="no_Data_small">{"NO DATA"}</div>
                )}
              </div>
            </div>
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel4"}
          isModulePopup={false}
          isShowPopup={this.state.isShowInvoicePopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl4}
          title={"Vendor Invoice Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl4}
              hideAlertCallBack={this.hideAlertCallBackLvl4}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                type="submit"
                bssize="sm"
                disabled={this.state.isVoided}
                onClick={(e) => this.saveCheckTransactionVendorInvoiceLine(e)}
              >
                Add/UpDate
              </Button>

              <Button
                className="header_buttons enterFocus"
                type="submit"
                bssize="sm"
                disabled={this.state.isDisablePopupFields}
                onClick={(e) => this.clearCheckTransactionLineValues(e)}
              >
                Clear{" "}
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">
                    CheckTransaction#
                  </FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.onCheckTransactionLineChange}
                    name="code"
                    value={checkTransactionData.code}
                    disabled={true}
                  />
                </Col>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">LineNumber</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    name="lineNumber"
                    onChange={this.onCheckTransactionLineChange}
                    readOnly={true}
                    value={checkTransactionLineData.lineNumber}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">ManualEntry</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputCheckbox
                    name="isManualEntry"
                    onChange={this.onChange}
                    type="checkbox"
                    checked={checkTransactionData.isManualEntry}
                    disabled={this.state.isDisablePopupFields}
                  />{" "}
                </Col>

                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">Invoice#</FormLabel>{" "}
                </Col>
                {checkTransactionData.isManualEntry === false && (
                  <Col sm="4">
                    <InputTextbox
                      name="invoiceNumber"
                      placeholder="Enter invoiceNumber"
                      onChange={this.onVendorInvoiceChange}
                      ref={this.invoiceRef}
                      value={checkTransactionLineData.invoiceNumber}
                      lookupRequired={true}
                      lookupHandler={this.state.vendorInvoiceLookupHandler}
                      searchCriteriaDialog={true}
                      disabled={this.state.isDisablePopupFields}
                      enterKeyEventHandler={
                        this.vendorInvoiceEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.state.vendorInvoicePageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayVendorInvoiceAutoCompleteList
                      }
                      showAutoCompleteList={
                        this.state.isShowAutoCompleteVendorInvoiceList
                      }
                      isMandatory={true}
                    />
                  </Col>
                )}
                {checkTransactionData.isManualEntry === true && (
                  <Col sm="4">
                    <InputTextbox
                      ref={this.invoiceRef}
                      name="invoiceNumber"
                      onChange={this.onCheckTransactionLineChange}
                      value={checkTransactionLineData.invoiceNumber}
                      placeholder="Enter invoice"
                      disabled={this.state.isDisablePopupFields}
                    />{" "}
                  </Col>
                )}
              </Row>
              {!checkTransactionData.isManualEntry && (
                <Row>
                  <Col className="so-align-items-left" sm="2">
                    <FormLabel className="header_labels">OrderDate</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      onChange={this.onCheckTransactionLineChange}
                      name="invoiceDate"
                      value={checkTransactionLineData.invoiceDate}
                      disabled={true}
                    ></DatePickerComponent>
                  </Col>
                  <Col className="so-align-items-left" sm="2">
                    <FormLabel className="header_labels">DueDate</FormLabel>{" "}
                  </Col>

                  <Col sm="4">
                    <DatePickerComponent
                      onChange={this.onCheckTransactionLineChange}
                      name="invoiceDueDate"
                      value={checkTransactionLineData.invoiceDueDate}
                      disabled={true}
                    ></DatePickerComponent>
                  </Col>
                </Row>
              )}
              {checkTransactionData.isManualEntry && (
                <Row>
                  <Col className="so-align-items-left" sm="2">
                    <FormLabel className="header_labels">OrderDate</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      onChange={this.onCheckTransactionLineChange}
                      name="invoiceDate"
                      value={checkTransactionLineData.invoiceDate}
                      disabled={this.state.isManualinvoiceEntry}
                    ></DatePickerComponent>
                  </Col>
                  <Col className="so-align-items-left" sm="2">
                    <FormLabel className="header_labels">DueDate</FormLabel>{" "}
                  </Col>

                  <Col sm="4">
                    <DatePickerComponent
                      onChange={this.onCheckTransactionLineChange}
                      name="invoiceDueDate"
                      value={checkTransactionLineData.invoiceDueDate}
                      disabled={this.state.isManualinvoiceEntry}
                    ></DatePickerComponent>
                  </Col>
                </Row>
              )}

              {!checkTransactionData.isManualEntry && (
                <Row>
                  <Col className="so-align-items-left" sm="2">
                    <FormLabel className="header_labels">GrandTotal</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      name="invoiceGrandTotalAmount"
                      value={checkTransactionLineData.invoiceGrandTotalAmount}
                      onChange={this.onCheckTransactionLineChange}
                      className="text-right"
                      decimalScale={2}
                      disabled={true}
                    />
                  </Col>
                  <Col className="so-align-items-left" sm="2">
                    <FormLabel className="header_labels">AmountDue</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      name="invoiceOpenAmount"
                      value={checkTransactionLineData.invoiceOpenAmount}
                      onChange={this.onCheckTransactionLineChange}
                      className="text-right"
                      decimalScale={2}
                      disabled={true}
                    />
                  </Col>
                </Row>
              )}

              {checkTransactionData.isManualEntry && (
                <Row>
                  <Col className="so-align-items-left" sm="2">
                    <FormLabel className="header_labels">
                      Invoice Amount
                    </FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      name="invoiceGrandTotalAmount"
                      value={checkTransactionLineData.invoiceGrandTotalAmount}
                      onChange={this.onCheckTransactionLineChange}
                      className="text-right"
                      decimalScale={2}
                      disabled={this.state.isManualinvoiceEntry}
                    />
                  </Col>
                  <Col className="so-align-items-left" sm="2">
                    <FormLabel className="header_labels">
                      Discount Amount
                    </FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      name="invoiceDiscountAmount"
                      value={checkTransactionLineData.invoiceDiscountAmount}
                      onChange={this.onCheckTransactionLineChange}
                      className="text-right"
                      decimalScale={2}
                      disabled={this.state.isManualinvoiceEntry}
                    />
                  </Col>
                </Row>
              )}

              <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">Amount</FormLabel>{" "}
                </Col>
                {!checkTransactionData.isManualEntry && (
                  <Col sm="4">
                    <NumberFormatInputbox
                      name="invoiceLinePaidAmount"
                      value={checkTransactionLineData.invoiceLinePaidAmount}
                      onChange={this.onCheckTransactionLineChange}
                      className="text-right"
                      decimalScale={2}
                      disabled={isDisableBasedOnManual}
                      isMandatory={true}
                      // disabled={false}
                    />
                  </Col>
                )}
                {checkTransactionData.isManualEntry && (
                  <Col sm="4">
                    <NumberFormatInputbox
                      name="invoiceLinePaidAmount"
                      value={checkTransactionLineData.invoiceLinePaidAmount}
                      onChange={this.onCheckTransactionLineChange}
                      className="text-right"
                      decimalScale={2}
                      disabled={true}
                    />
                  </Col>
                )}

                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">ExpType</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.invExpenseTypeOnChange}
                    placeholder="expenseType"
                    name="expenseType"
                    value={checkTransactionLineData.expenseType}
                    lookupRequired={true}
                    lookupHandler={this.state.expenseTypeLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.invExpenseTypeEnterKeyEvent}
                    autoCompleteListData={
                      this.state.invExpenseTypePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayInvExpenseTypeAutoCompleteList
                    }
                    showAutoCompleteList={
                      this.state.isShowAutoCompleteInvExpenseTypeList
                    }
                    disabled={this.state.isDisablePopupFields}
                    isMandatory={true}
                  />
                </Col>
              </Row>
              {/* <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">ExpSubType</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.invExpenseSubTypeOnChange}
                    placeholder="expenseSubType"
                    name="expenseSubType"
                    value={checkTransactionLineData.expenseSubType}
                    lookupRequired={true}
                    lookupHandler={this.state.expenseSubTypeLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.invExpenseSubTypeEnterKeyEvent}
                    autoCompleteListData={
                      this.state.invExpenseSubTypePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayInvExpenseSubTypeAutoCompleteList
                    }
                    showAutoCompleteList={
                      this.state.isShowAutoCompleteInvExpenseSubTypeList
                    }
                    disabled={this.state.isDisablePopupFields}
                    isMandatory={true}
                  />
                </Col>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">Currency#</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.currencyOnChange}
                    placeholder="currencyCode"
                    name="currencyCode"
                    value={checkTransactionLineData.currencyCode}
                    lookupRequired={true}
                    lookupHandler={this.state.currencyLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.currencyEnterKeyEvent}
                    autoCompleteListData={
                      this.state.currencyPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayCurrencyAutoCompleteList
                    }
                    showAutoCompleteList={
                      this.state.isShowAutoCompleteCurrencyList
                    }
                    disabled={this.state.isDisablePopupFields}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">Description</FormLabel>{" "}
                </Col>
                <Col sm="10">
                  <InputTextbox
                    name="invoiceDescription"
                    onChange={this.onCheckTransactionLineChange}
                    value={checkTransactionLineData.invoiceDescription}
                    disabled={this.state.isVoided}
                  />{" "}
                </Col>
              </Row> */}
            </div>
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel5"}
          isModulePopup={false}
          isShowPopup={this.state.isShowPrintPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl5}
          title={"CHECK PRINT DETAIL"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl5}
              hideAlertCallBack={this.hideAlertCallBackLvl5}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                type="submit"
                bssize="sm"
                onClick={(e) => this.printCheck(e)}
              >
                Print{" "}
              </Button>

              <Button
                className="header_buttons enterFocus"
                type="submit"
                bssize="sm"
                onClick={(e) => this.closeCheckTransactionPrint(e)}
              >
                Close{" "}
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Check#</FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="checkNumber"
                    value={this.state.checkNumber}
                    disabled={true}
                  />{" "}
                </Col>
                <Col sm="3">
                  <DatePickerComponent
                    onChange={this.onChange}
                    name="checkDate"
                    value={checkTransactionData.checkDate}
                  ></DatePickerComponent>
                </Col>
              </Row>{" "}
              <Row>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>GrandTotal</FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <NumberFormatInputbox
                    name="invoiceGrandTotalAmount"
                    value={checkTransactionData.totalAmount}
                    onChange={this.onCheckTransactionLineChange}
                    className="text-right"
                    decimalScale={2}
                    disabled={true}
                  />
                </Col>
              </Row>{" "}
            </div>
          }
        />{" "}
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel5"}
          isModulePopup={false}
          isShowPopup={this.state.isShowGlAccountPopup}
          closeOnEsc={true}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl6}
          title={"GL Account Applied Entry "}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl6}
              hideAlertCallBack={this.hideAlertCallBackLvl6}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.addGlAccountLines(e)}
                // disabled={this.state.isDisabledFields}
              >
                Add/Update
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col sm="2">
                  <FormLabel>Check Transaction#</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    name="checkTransactionNumber"
                    value={glAccountLinedata.checkTransactionNumber}
                    onChange={this.onGlAccountChange}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="4">
                  <FormLabel>GL Account Apply Details #</FormLabel>{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>GL Account</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    name="glAccountNumber"
                    value={glAccountLinedata.glAccountNumber}
                    onChange={this.onGlAccountChange}
                  />
                </Col>
                <Col sm="2">
                  <FormLabel>Amount</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    name="appliedAmount"
                    value={glAccountLinedata.appliedAmount}
                    onChange={this.onGlAccountChange}
                  />
                </Col>
              </Row>
            </div>
          }
        />
      </div>
    );
  }
}
class CheckTransactionListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkTransactionCriteria: new CheckTransactionSearchCriteria(),
      filter: "",
      pageList: this.props.pageList,
      criteria: this.props.criteria,
    };
    this.searchRef = React.createRef();
  }
  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }
  listFormOnChange = (e) => {
    this.props.listFormOnChange(e);
  };
  resetCheckTransaction = (e) => {
    if (e.detail == 1) this.props.resetCheckTransaction();
  };
  filterCheckTransaction = (e) => {
    if (e.detail == 1) this.props.filterCheckTransaction();
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  editCheckTransaction = (e, val) => {
    if (e.detail == 1) this.props.editCheckTransaction(val);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterCheckTransaction();
    }
  };
  render() {
    let check_transaction_list = this.props.check_transaction_list;
    let checkTransactionCriteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="checkTransactionNumberContains"
                type="text"
                value={checkTransactionCriteria.checkTransactionNumberContains}
                placeholder="Enter Value to Filter.."
                onChange={this.listFormOnChange}
                onKeyDown={this.onKeyDown}
              />
              <Button onClick={(e) => this.filterCheckTransaction(e)}>
                Filter
              </Button>
              <Button onClick={(e) => this.resetCheckTransaction(e)}>
                Reset
              </Button>
            </span>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <Table id="fabrics_tables_default">
          <thead>
            <th onClick={(e) => this.handleSortingChange(e, "code")}>
              CheckTransaction
              {this.props.order === "desc" &&
              this.props.sortField === "code" ? (
                <span className="drp-dwn-cntr">
                  <DropDwnUp />
                </span>
              ) : (
                <span className="drp-dwn-cntr">
                  <DropDwnDown />
                </span>
              )}
            </th>
            <th onClick={(e) => this.handleSortingChange(e, "vendorCode")}>
              Vendor
              {this.props.order === "desc" &&
              this.props.sortField === "vendorCode" ? (
                <span className="drp-dwn-cntr">
                  <DropDwnUp />
                </span>
              ) : (
                <span className="drp-dwn-cntr">
                  <DropDwnDown />
                </span>
              )}
            </th>
            <th onClick={(e) => this.handleSortingChange(e, "transactionType")}>
              Transaction Type
              {this.props.order === "desc" &&
              this.props.sortField === "transactionType" ? (
                <span className="drp-dwn-cntr">
                  <DropDwnUp />
                </span>
              ) : (
                <span className="drp-dwn-cntr">
                  <DropDwnDown />
                </span>
              )}
            </th>
            <th onClick={(e) => this.handleSortingChange(e, "bankCode")}>
              Bank
              {this.props.order === "desc" &&
              this.props.sortField === "bankCode" ? (
                <span className="drp-dwn-cntr">
                  <DropDwnUp />
                </span>
              ) : (
                <span className="drp-dwn-cntr">
                  <DropDwnDown />
                </span>
              )}
            </th>
            <th onClick={(e) => this.handleSortingChange(e, "status")}>
              Status
              {this.props.order === "desc" &&
              this.props.sortField === "status" ? (
                <span className="drp-dwn-cntr">
                  <DropDwnUp />
                </span>
              ) : (
                <span className="drp-dwn-cntr">
                  <DropDwnDown />
                </span>
              )}
            </th>
          </thead>
          <tbody>
            {check_transaction_list.map((list, index) => (
              <tr key={index}>
                <Button
                  variant="secondry"
                  className="hyperLinkText"
                  onClick={(e) => this.editCheckTransaction(e, list.code)}
                >
                  {list.code}
                </Button>
                <td className="text-right">{list.vendorCode}</td>
                <td className="text-right">{list.transactionType}</td>
                <td className="text-right">{list.bankCode}</td>
                <td className="text-right">
                  {ModuleUtils.getCheckTransactionStatusCaption(list.status)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {check_transaction_list.length != 0 ? null : (
          <div className="no_Data_small">{"NO DATA"}</div>
        )}
      </div>
    );
  }
}
class CheckTransactionEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.vendorInvoiceCodeRef = React.createRef();
    this.purchaseReceiptCodeRef = React.createRef();
    this.adjReasonCodeRef = React.createRef();
    this.miscReasonCodeRef = React.createRef();
    this.vendorRef = React.createRef();
    this.state = {
      //
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.vendorRef.current != null) {
      this.vendorRef.current.focus();
    }
  }
  initLookupHandlers = () => {
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor"
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
    let bankLookupHandler = new GenericAttributeLookupHandler(
      this.props.banks,
      "Bank"
    );
    this.setState({ bankLookupHandler: bankLookupHandler });
    let transactionTypeLookupHandler = new GenericAttributeLookupHandler(
      this.props.transactionTypes,
      "Transaction Type"
    );
    this.setState({
      transactionTypeLookupHandler: transactionTypeLookupHandler,
    });
  };
  getChecktransactionInvoiceLineDetails = (e, rowData) => {
    if (e.detail == 1)
      this.props.getChecktransactionInvoiceLineDetails(rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  deleteCheckTransactionVendorInvoiceLine = (e, rowData) => {
    if (e.detail == 1)
      this.props.deleteCheckTransactionVendorInvoiceLine(rowData);
  };
  deleteLOCLine = (e, rowData) => {
    if (e.detail == 1) this.props.deleteLOCLine(rowData);
  };
  getLocLineDetails = (e, value, rowData) => {
    if (e.detail == 1) this.props.getLocLineDetails(rowData);
  };
  openMultipleInvoiceForm = (e) => {
    if (e.detail == 1) this.props.openMultipleInvoiceForm();
  };
  onVendorCodeChange = (e) => {
    this.props.onVendorCodeChange(e);
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    this.props.vendorCodeEnterKeyEventHandler(e);
  };
  displayVendorAutoCompleteList = (list) => {
    this.props.displayVendorAutoCompleteList(list);
  };
  openInvoiceForm = (e) => {
    if (e.detail == 1) this.props.openInvoiceForm(0);
  };
  openLetterOfCreditForm = (e) => {
    if (e.detail == 1) this.props.openLetterOfCreditForm(0);
  };
  /**
   *
   * @param {boolean} showAutoCompleteList
   * return boolean
   */
  transTypeOnChange = (e) => {
    this.props.transTypeOnChange(e);
  };
  transTypeEnterKeyEvent = (e) => {
    this.props.transTypeEnterKeyEvent(e);
  };
  displayTransTypeAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayTransTypeAutoCompleteList(showAutoCompleteList);
  };
  bankOnChange = (e) => {
    this.props.bankOnChange(e);
  };
  bankEnterKeyEvent = (e) => {
    this.props.bankEnterKeyEvent(e);
  };
  displayBankAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayBankAutoCompleteList(showAutoCompleteList);
  };
  viewLocModule = (e, code, rowData) => {
    if (e.detail == 1) this.props.viewLocModule(code);
  };
  handleSortingChange = (accessor) => {
    this.props.handleSortingChange(accessor);
  };
  handleSortingInvoiceLineSortingChange = (e, accessor) => {
    if (e.detail == 1)
      this.props.handleSortingInvoiceLineSortingChange(accessor);
  };
  handleSortingLocLineChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingLocLineChange(accessor);
  };

  glAccountForm = (e) => {
    if (e.detail == 1) this.props.glAccountForm();
  };
  editGlAccountLineDetail = (e, val, rowData) => {
    if (e.detail == 1) this.props.editGlAccountLineDetail(rowData);
  };
  deleteGlAccountLine = (e, line) => {
    if (e.detail == 1) this.props.deleteGlAccountLine(line);
  };
  handleSortingGLChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingGLChange(accessor);
  };

  render() {
    let checkTransactionData = null;
    checkTransactionData = this.props.checkTransactionData;
    let checkTransactionLineData = this.props.checkTransactionLineData;
    let isDisabledFields = this.props.isDisabledFields;
    let inVoiceSortingLines = this.props.inVoiceSortingLines;

    let isDisableMultiInvoice = true;
    if (
      checkTransactionData.status ===
      LogicConstants.CHECK_TRANSACTION_OPEN_STATUS
    ) {
      isDisableMultiInvoice = false;
    }
    let invoiceLines = [];
    if (checkTransactionData.invoiceLines != null) {
      checkTransactionData.invoiceLines.map((line) => {
        invoiceLines.push(line);
      });
    }
    let locLines = [];
    if (checkTransactionData.letterOfCreditLines != null) {
      checkTransactionData.letterOfCreditLines.map((line) => {
        locLines.push(line);
      });
    }
    let isCheckTransactionType = false;
    if (checkTransactionData.transactionType != "CHECK") {
      isCheckTransactionType = true;
    }
    let locLineList = this.props.locLineList;
    let glAccountLines = this.props.glAccountLines;

    const text_Area_Style = {
      maxHeight: "12em",
      width: "50em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
    };

    const textAreaStyle = {
      height: "4em",
      width: "76em",
      resize: "none",
      padding: "2px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    if (this.props.isViewMode) {
      isCheckTransactionType = true;
      isDisableMultiInvoice = true;
    }
    return (
      <div>
        <div>
          <div>
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>Date</FormLabel>
              </Col>
              <Col className="align-items-left" sm="2">
                <DatePickerComponent
                  name="createdDate"
                  onChange={this.onChange}
                  value={checkTransactionData.createdDate}
                  disabled={isDisabledFields}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Vendor#</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  ref={this.vendorRef}
                  name="vendorCode"
                  placeholder="Enter Vendor"
                  onChange={this.onVendorCodeChange}
                  value={checkTransactionData.vendorCode}
                  lookupRequired={true}
                  lookupHandler={this.state.vendorLookupHandler}
                  searchCriteriaDialog={true}
                  disabled={isDisabledFields}
                  enterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.vendorPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayVendorAutoCompleteList}
                  showAutoCompleteList={this.props.isShowAutoCompleteVendorList}
                  isMandatory={true}
                />
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="vendorName"
                  onChange={this.onVendorCodeChange}
                  value={checkTransactionData.vendorName}
                  readOnly={true}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Trans Type</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.transTypeOnChange}
                  placeholder="transactionType"
                  name="transactionType"
                  value={checkTransactionData.transactionType}
                  lookupRequired={true}
                  lookupHandler={this.state.transactionTypeLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.transTypeEnterKeyEvent}
                  autoCompleteListData={
                    this.props.transTypePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayTransTypeAutoCompleteList
                  }
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteTransTypeList
                  }
                  readOnly={isDisabledFields}
                  disabled={isDisabledFields}
                  isMandatory={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel
                  className="hyperlinklabel"
                  onClick={(e) => this.props.addressClickHandler(e)}
                >
                  Address
                </FormLabel>
              </Col>
            </Row>
            <Row></Row>
          </div>
          <div className="div_inline ">
            <div className="div_80_no_overflow ">
              <div className="header_div div_Custom_6">
                {this.props.isCheckType && (
                  <div>
                    <Row>
                      <Col>
                        <FormLabel className="label_head">Check Details</FormLabel>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Bank</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          onChange={this.bankOnChange}
                          placeholder="bankCode"
                          name="bankCode"
                          value={checkTransactionData.bankCode}
                          lookupRequired={true}
                          // lookupRequired={this.props.isShowLookup}
                          lookupHandler={this.state.bankLookupHandler}
                          showCriteriaDialog={true}
                          enterKeyEventHandler={this.bankEnterKeyEvent}
                          autoCompleteListData={
                            this.props.bankPageListForAutoCompleteList
                          }
                          enableAutoCompleteTextBox={true}
                          displayAutoCompleteList={
                            this.displayBankAutoCompleteList
                          }
                          showAutoCompleteList={
                            this.props.isShowAutoCompleteBankList
                          }
                          readOnly={isDisabledFields}
                          disabled={isDisabledFields}
                          isMandatory={true}
                        />
                      </Col>
                      <Col sm="3">
                        <InputTextbox
                          name="bankName"
                          onChange={this.onChange}
                          value={checkTransactionData.bankName}
                          readOnly={true}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Check</FormLabel>
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="checkNumber"
                          value={checkTransactionData.checkNumber}
                          onChange={this.onChange}
                          disabled={true}
                        />
                      </Col>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>CheckDate</FormLabel>
                      </Col>
                      <Col sm="2">
                        <DatePickerComponent
                          name="checkDate"
                          value={checkTransactionData.checkDate}
                          onChange={this.onChange}
                          disabled={isDisabledFields}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Total Amt</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="totalAmount"
                          onChange={this.onChange}
                          value={checkTransactionData.totalAmount}
                          readOnly={true}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Currency</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="bankCurrencyCode"
                          onChange={this.onChange}
                          readOnly={true}
                          value={checkTransactionData.bankCurrencyCode}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>MemoText</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="memoText"
                          onChange={this.onChange}
                          readOnly={false}
                          value={checkTransactionData.memoText}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>
                      {this.props.isPrinted && (
                        <Col className="align-items-left" sm="1">
                          <FormLabel>MemoText</FormLabel>
                        </Col>
                      )}
                      {this.props.isPrinted && (
                        <Col sm="2">
                          <InputTextbox
                            value={checkTransactionData.checkNumber}
                            disabled={true}
                          />{" "}
                        </Col>
                      )}
                    </Row>
                  </div>
                )}
                {this.props.isWireType && (
                  <div>
                    <Row>
                      <Col>
                        <FormLabel>Wire Details</FormLabel>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Wire#</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="wireTransferReferenceNumber"
                          onChange={this.onChange}
                          value={
                            checkTransactionData.wireTransferReferenceNumber
                          }
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Transfer Date</FormLabel>
                      </Col>
                      <Col sm="2">
                        <DatePickerComponent
                          name="wireTransferDate"
                          value={checkTransactionData.wireTransferDate}
                          onChange={this.onChange}
                          disabled={isDisabledFields}
                        />
                      </Col>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Bank</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          onChange={this.bankOnChange}
                          placeholder="bankCode"
                          name="bankCode"
                          value={checkTransactionData.bankCode}
                          lookupRequired={true}
                          // lookupRequired={this.props.isShowLookup}
                          lookupHandler={this.state.bankLookupHandler}
                          showCriteriaDialog={true}
                          enterKeyEventHandler={this.bankEnterKeyEvent}
                          autoCompleteListData={
                            this.props.bankPageListForAutoCompleteList
                          }
                          enableAutoCompleteTextBox={true}
                          displayAutoCompleteList={
                            this.displayBankAutoCompleteList
                          }
                          showAutoCompleteList={
                            this.props.isShowAutoCompleteBankList
                          }
                          readOnly={isDisabledFields}
                          disabled={isDisabledFields}
                        />
                      </Col>
                      <Col sm="3">
                        <InputTextbox
                          name="bankName"
                          onChange={this.onChange}
                          value={checkTransactionData.bankName}
                          readOnly={true}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Total Amt</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <NumberFormatInputbox
                          name="totalAmount"
                          onChange={this.onChange}
                          value={checkTransactionData.totalAmount}
                          readOnly={true}
                          disabled={isDisabledFields}
                          decimalScale={2}
                        />{" "}
                      </Col>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Currency</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="bankCurrencyCode"
                          onChange={this.onChange}
                          readOnly={true}
                          value={checkTransactionData.bankCurrencyCode}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>
                    </Row>
                    <Row>
                      {" "}
                      <Col className="align-items-left" sm="1">
                        <FormLabel>MemoText</FormLabel>{" "}
                      </Col>
                      <Col sm="8">
                        <InputTextbox
                          name="memoText"
                          onChange={this.onChange}
                          readOnly={false}
                          value={checkTransactionData.memoText}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="1">
                        <FormLabel>WireInfo</FormLabel>
                      </Col>
                      <Col sm="3">
                        <textarea
                          style={textAreaStyle}
                          className="form-control"
                          type="text"
                          name="wireTransferInformation"
                          value={checkTransactionData.wireTransferInformation}
                          onChange={this.onChange}
                          disabled={isDisabledFields}
                        />
                      </Col>
                    </Row>
                  </div>
                )}
                {this.props.isWirewithLCType && (
                  <div>
                    <Row>
                      <Col>
                        <FormLabel>Wire With LC Details</FormLabel>
                      </Col>
                    </Row>
                    <Row>
                      {" "}
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Total Amt</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <NumberFormatInputbox
                          name="totalAmount"
                          onChange={this.onChange}
                          value={checkTransactionData.totalAmount}
                          readOnly={true}
                          disabled={isDisabledFields}
                          decimalScale={2}
                        />{" "}
                      </Col>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Currency</FormLabel>{" "}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          name="bankCurrencyCode"
                          onChange={this.onChange}
                          readOnly={true}
                          value={checkTransactionData.bankCurrencyCode}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>MemoText</FormLabel>{" "}
                      </Col>
                      <Col sm="8">
                        <InputTextbox
                          name="memoText"
                          onChange={this.onChange}
                          value={checkTransactionData.memoText}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>
                    </Row>
                  </div>
                )}
              </div>
            </div>
            {/* <div className="div_20_no_overflow">
              <div className="header_div">
                <Row>
                  <Col className="align-items-left">
                    <FormLabel>Currency</FormLabel>{" "}
                  </Col>
                  <Col>
                    <InputTextbox
                      name="currencyCode"
                      onChange={this.onChange}
                      readOnly={true}
                      className="summary_input text-right"
                      value={checkTransactionData.currencyCode}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col className="align-items-left">
                    <FormLabel>Cur.Ex</FormLabel>{" "}
                  </Col>
                  <Col>
                    <NumberFormatInputbox
                      ref={this.itemShortNameRef}
                      name="adjustedExchangeRate"
                      onChange={this.onChange}
                      className="summary_input text-right"
                      value={checkTransactionData.adjustedExchangeRate}
                      disabled={true}
                      decimalScale={2}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col className="align-items-left">
                    <FormLabel>Standard Amt</FormLabel>{" "}
                  </Col>
                  <Col>
                    <NumberFormatInputbox
                      ref={this.itemShortNameRef}
                      name="standardTotalAmount"
                      onChange={this.onChange}
                      className="summary_input text-right"
                      value={checkTransactionData.standardTotalAmount}
                      disabled={true}
                      decimalScale={2}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col className="align-items-left">
                    <FormLabel>Tax%</FormLabel>{" "}
                  </Col>
                  <Col>
                    <NumberFormatInputbox
                      ref={this.itemShortNameRef}
                      name="taxPercentage"
                      onChange={this.onChange}
                      className="summary_input text-right"
                      value={checkTransactionData.taxPercentage}
                      disabled={true}
                      decimalScale={2}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col className="align-items-left">
                    <FormLabel>TaxAmt</FormLabel>{" "}
                  </Col>
                  <Col>
                    <NumberFormatInputbox
                      name="taxAmount"
                      onChange={this.onChange}
                      className="summary_input text-right"
                      value={checkTransactionData.taxAmount}
                      disabled={true}
                      decimalScale={2}
                    />{" "}
                  </Col>
                </Row>
              </div>
            </div> */}
          </div>
        </div>
        <div>
          {!this.props.isWirewithLCType ? (
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel className="label_head">INVOICE LINES</FormLabel>{" "}
              </Col>
              {/* <Col className="align-items-left" sm="2">
                {!checkTransactionData.isManualEntry && (
                  <Button
                    size="sm"
                    // disabled={isDisabledFields}
                    disabled={isDisableMultiInvoice}
                    onClick={(e) => this.openMultipleInvoiceForm(e)}
                    id="fabric_Add_Button"
                  >
                    <AddIcon />
                    {"Multiple Invoices"}
                  </Button>
                )}
              </Col> */}
            </Row>
          ) : (
            <Row>
              <Col className="align-items-left">
                <FormLabel>LETTER OF CREDITS LINES</FormLabel>{" "}
              </Col>
            </Row>
          )}
          {!this.props.isWirewithLCType ? (
            <div className="div_Custom_3">
              <Table id="fabrics_tables">
                <thead>
                  <tr>
                    <th>
                      <Button
                        size="sm"
                        onClick={(e) => this.openInvoiceForm(e)}
                        disabled={this.props.isVoided}
                        id="fabric_Add_Button"
                      >
                        <AddIcon />
                      </Button>
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingInvoiceLineSortingChange(
                          e,
                          "invoiceNumber"
                        )
                      }
                    >
                      Invoice
                      {this.props.order === "desc" &&
                      this.props.sortField === "invoiceNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingInvoiceLineSortingChange(
                          e,
                          "invoiceDate"
                        )
                      }
                    >
                      Invoice Date
                      {this.props.order === "desc" &&
                      this.props.sortField === "invoiceDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingInvoiceLineSortingChange(
                          e,
                          "invoiceDueDate"
                        )
                      }
                    >
                      Due Date
                      {this.props.order === "desc" &&
                      this.props.sortField === "invoiceDueDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingInvoiceLineSortingChange(
                          e,
                          "invoiceGrandTotalAmount"
                        )
                      }
                    >
                      Invoice totAmt
                      {this.props.order === "desc" &&
                      this.props.sortField === "invoiceGrandTotalAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingInvoiceLineSortingChange(
                          e,
                          "invoiceOpenAmount"
                        )
                      }
                    >
                      Amount Due
                      {this.props.order === "desc" &&
                      this.props.sortField === "invoiceOpenAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingInvoiceLineSortingChange(
                          e,
                          "invoiceDiscountAmount"
                        )
                      }
                    >
                      {" "}
                      Discount Amount
                      {this.props.order === "desc" &&
                      this.props.sortField === "invoiceDiscountAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingInvoiceLineSortingChange(
                          e,
                          "invoiceLinePaidAmount"
                        )
                      }
                    >
                      Amount
                      {this.props.order === "desc" &&
                      this.props.sortField === "invoiceLinePaidAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingInvoiceLineSortingChange(
                          e,
                          "expenseType"
                        )
                      }
                    >
                      ExpenseType
                      {this.props.order === "desc" &&
                      this.props.sortField === "expenseType" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingInvoiceLineSortingChange(
                          e,
                          "expenseSubType"
                        )
                      }
                    >
                      ExpenseSubType
                      {this.props.order === "desc" &&
                      this.props.sortField === "expenseSubType" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {inVoiceSortingLines.map((ln, index) => (
                    <tr key={index}>
                      <td>
                        {" "}
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.getChecktransactionInvoiceLineDetails(e, ln)
                          }
                        >
                          {ln.lineNumber}
                        </Button>
                      </td>
                      <td>{ln.invoiceNumber}</td>
                      <td>{ln.invoiceDate}</td>
                      <td>{ln.invoiceDueDate}</td>
                      <td className="text-right">
                        {ln.invoiceGrandTotalAmount}
                      </td>
                      <td className="text-right">{ln.invoiceOpenAmount}</td>
                      <td className="text-right">{ln.invoiceDiscountAmount}</td>
                      <td className="text-right">{ln.invoiceLinePaidAmount}</td>
                      <td>{ln.expenseType}</td>
                      <td>{ln.expenseSubType}</td>
                      <td>
                        <Button
                          disabled={ln.isFetched}
                          onClick={(e) =>
                            this.deleteCheckTransactionVendorInvoiceLine(e, ln)
                          }
                        >
                          <DeleteIcon />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {inVoiceSortingLines.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
            </div>
          ) : (
            <div className="div_Custom_3">
              <Table id="fabrics_tables">
                <thead>
                  <tr>
                    <th
                      onClick={(e) =>
                        this.handleSortingLocLineChange(e, "lineNumber")
                      }
                    >
                      <Button
                        size="sm"
                        disabled={isDisabledFields}
                        onClick={(e) => this.openLetterOfCreditForm(e)}
                        id="fabric_Add_Button"
                      >
                        <AddIcon />
                      </Button>
                      {this.props.order === "desc" &&
                      this.props.sortField === "lineNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingLocLineChange(
                          e,
                          "letterOfCreditNumber"
                        )
                      }
                    >
                      LOC
                      {this.props.order === "desc" &&
                      this.props.sortField === "letterOfCreditNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingLocLineChange(
                          e,
                          "letterOfCreditAmount"
                        )
                      }
                    >
                      LOC Amount
                      {this.props.order === "desc" &&
                      this.props.sortField === "letterOfCreditAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingLocLineChange(e, "letterOfCreditDate")
                      }
                    >
                      LOC Date
                      {this.props.order === "desc" &&
                      this.props.sortField === "letterOfCreditDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingLocLineChange(e, "bankCode")
                      }
                    >
                      BankCode
                      {this.props.order === "desc" &&
                      this.props.sortField === "bankCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingLocLineChange(e, "bankName")
                      }
                    >
                      BankName
                      {this.props.order === "desc" &&
                      this.props.sortField === "bankName" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {locLineList.map((ln, index) => (
                    <tr key={index}>
                      <td>
                        {" "}
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.getLocLineDetails(e, ln.lineNumber, ln)
                          }
                        >
                          {ln.lineNumber}
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewLocModule(e, ln.letterOfCreditNumber, ln)
                          }
                        >
                          {ln.letterOfCreditNumber}
                        </Button>
                      </td>
                      <td className="text-right">{ln.letterOfCreditAmount}</td>
                      <td>{ln.letterOfCreditDate}</td>
                      <td>{ln.bankCode}</td>
                      <td>{ln.bankName}</td>
                      <td>
                        <Button
                          onClick={(e) => this.deleteLOCLine(e, ln)}
                          disabled={isDisabledFields}
                        >
                          <DeleteIcon />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {locLineList.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
            </div>
          )}
        </div>
        <div className="div_inline">
          <div className="div_60_no_overflow">
            <div className="div_Custom_3">
              <Table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th
                      onClick={(e) =>
                        this.handleSortingGLChange(e, "glAccountNumber")
                      }
                    >
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        onClick={(e) => this.glAccountForm(e)}
                      >
                        <AddIcon />
                      </Button>
                      GL Account
                      {this.props.order === "desc" &&
                      this.props.sortField === "glAccountNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingGLChange(e, "AppliedAmount")
                      }
                    >
                      Applied Amount
                      {this.props.order === "desc" &&
                      this.props.sortField === "AppliedAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th>Remove</th>
                  </tr>
                </thead>
                {glAccountLines != null ? (
                  <tbody>
                    {glAccountLines.map((ln, index) => (
                      <tr key={index}>
                        <td className="hyperLinkText">
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.editGlAccountLineDetail(
                                e,
                                ln.glAccountNumber,
                                ln
                              )
                            }
                          >
                            {ln.glAccountNumber}
                          </Button>
                        </td>
                        <td>{ln.appliedAmount}</td>
                        <td>
                          <Button
                            // id="fabric_Add_Button"
                            // className="enterFocus"
                            // size="sm1"
                            // bssize="large"
                            disabled={ln.isFetched}
                            onClick={(e) =>
                              this.deleteGlAccountLine(
                                e,
                                ln.glAccountNumber,
                                glAccountLines
                              )
                            }
                          >
                            <DeleteIcon />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : null}
              </Table>
            </div>
          </div>
          <div>
            <Row>
              <Col sm="1">
                <FormLabel>Comments</FormLabel>
              </Col>
            </Row>
            <Row>
              {" "}
              <Col>
                <textarea
                  style={text_Area_Style}
                  className="form-control"
                  type="text"
                  name="comments"
                  onChange={this.onChange}
                  value={checkTransactionData.comments}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}
class CheckTransactionHistoryDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    //
  }
  render() {
    let printHistories = this.props.printHistoriesList;
    let statusTracks = this.props.statusTracksList;
    if (!statusTracks) {
      statusTracks = new Array();
    }
    if (!printHistories) {
      printHistories = new Array();
    }
    // let checkTransactionData = this.props.checkTransactionData;
    // let statusTracks = new Array();
    // statusTracks = checkTransactionData.statusTracks;
    // let printHistories = new Array();
    // printHistories = checkTransactionData.printHistories;
    return (
      <div className="header_div">
        <div className="div_inline">
          {" "}
          <div class="div_Equal">
            <FormLabel  className="label_head">Status History</FormLabel>
            <Table id="fabrics_tables_default">
              <thead>
                <th
                  onClick={(e) =>
                    this.props.handleSortingStatusTrackChange(e, "createdDate")
                  }
                >
                  Date
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.props.handleSortingStatusTrackChange(
                      e,
                      "currentStatus"
                    )
                  }
                >
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "currentStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.props.handleSortingStatusTrackChange(
                      e,
                      "previousStatus"
                    )
                  }
                >
                  Previous Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "previousStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.props.handleSortingStatusTrackChange(e, "createdBy")
                  }
                >
                  Done By
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdBy" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.props.handleSortingStatusTrackChange(e, "remarks")
                  }
                >
                  Remarks
                  {this.props.order === "desc" &&
                  this.props.sortField === "remarks" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </thead>
              <tbody>
                {statusTracks.map((list, index) => (
                  <tr key={index}>
                    <td>{list.createdDate}</td>
                    <td>
                      {ModuleUtils.getCheckTransactionStatusCaption(
                        list.currentStatus
                      )}
                    </td>
                    <td>
                      {ModuleUtils.getCheckTransactionStatusCaption(
                        list.previousStatus
                      )}
                    </td>
                    <td>{list.createdBy}</td>
                    <td>{list.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {statusTracks.length != 0 ? null : (
              <div className="no_Data_small">{"NO DATA"}</div>
            )}
          </div>
          <div class="div_Equal">
            <FormLabel  className="label_head">Check Printed History</FormLabel>
            <Table id="fabrics_tables_default">
              <thead>
                <th
                  onClick={(e) =>
                    this.props.handleSortingPrintHistoriesChange(e, "printDate")
                  }
                >
                  Printed Date
                  {this.props.order === "desc" &&
                  this.props.sortField === "printDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.props.handleSortingPrintHistoriesChange(
                      e,
                      "checkNumber"
                    )
                  }
                >
                  Check
                  {this.props.order === "desc" &&
                  this.props.sortField === "checkNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.props.handleSortingPrintHistoriesChange(
                      e,
                      "checkTransactionNumber"
                    )
                  }
                >
                  CheckTransaction
                  {this.props.order === "desc" &&
                  this.props.sortField === "checkTransactionNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.props.handleSortingPrintHistoriesChange(
                      e,
                      "checkAmount"
                    )
                  }
                >
                  Check Amount
                  {this.props.order === "desc" &&
                  this.props.sortField === "checkAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.props.handleSortingPrintHistoriesChange(
                      e,
                      "currencyCode"
                    )
                  }
                >
                  Currency
                  {this.props.order === "desc" &&
                  this.props.sortField === "currencyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.props.handleSortingPrintHistoriesChange(e, "createdBy")
                  }
                >
                  Done By
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdBy" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </thead>
              <tbody>
                {printHistories.map((list, index) => (
                  <tr key={index}>
                    <td>{list.printDate}</td>
                    <td>{list.checkNumber}</td>
                    <td>{list.checkTransactionNumber}</td>
                    <td className="text-right">{list.checkAmount}</td>
                    <td>{list.currencyCode}</td>
                    <td>{list.createdBy}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {printHistories.length != 0 ? null : (
              <div className="no_Data_small">{"NO DATA"}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
function CheckTransactionModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div id="app_container"></div>
      <CheckTransactionList {...props} name="" /> <br />
    </div>
  );
}

export default CheckTransactionModule;
